import { lighten } from "@mui/material";
import { useTheme } from "@mui/system";
import React from "react";

const lightenCoefficient = 0.15;

export default function Logo(): JSX.Element {
  const theme = useTheme();

  const styleOne = { fill: "#242429" };
  const styleTwo = {
    fill:
      theme.palette.mode === "light"
        ? "#6580a4"
        : lighten("#6580a4", lightenCoefficient),
  };
  const styleThree = {
    fill:
      theme.palette.mode === "light"
        ? "#a8a56b"
        : lighten("#a8a56b", lightenCoefficient),
  };
  const styleFour = {
    fill:
      theme.palette.mode === "light"
        ? "#404049"
        : lighten("#404049", lightenCoefficient),
  };
  const styleFive = {
    fill:
      theme.palette.mode === "light"
        ? "#546273"
        : lighten("#546273", lightenCoefficient),
  };

  return (
    <svg
      version="1.1"
      viewBox="0 0 687 185.9"
      fill="currentColor"
      style={{ width: "100%" }}
    >
      <path
        style={styleOne}
        d="M177 181a2 2 0 01-1-2 2 2 0 000-1l-10-20a3 3 0 00-2-1h-1-1a4 4 0 010-3 3 3 0 000-2l-6-15-2-5c0-3-1-5-3-7l-3-6 1-1-1-2c0-1 0-3-2-3l-2-3v-1-3h-1l-1 2-1-1v-1a31 31 0 01-4-19l2-5 1 1 1 1 1-2v-4l-1-2 2-4 2-4h1v-4c2 0 3-2 5-3v-3h-2v-1a10 10 0 013-6l3-3v-3l1-2a4 4 0 012 1 2 2 0 010 1l1 1a2 2 0 001-1 2 2 0 00-1-3 3 3 0 00-1 0 2 2 0 00-2 1h-8a13 13 0 01-6-1 8 8 0 00-4-1 2 2 0 00-1 0v25a100 100 0 00-1 14l-1 3v9a1655 1655 0 010 19 3 3 0 00-2 2 3 3 0 001 2 7 7 0 011 1 2 2 0 001 1 3 3 0 011 2c-2 1-2 2-2 4l-1 4-1 3v10a16 16 0 01-2 0 16 16 0 00-2-1 5 5 0 00-3 1h-1l1-11c0-10 1-21-1-31l1-20V67l1-9 1-20c1-4 3-5 7-6a73 73 0 018 0 107 107 0 0122 2c4 1 5 3 6 6a17 17 0 015 1 16 16 0 005 1 7 7 0 003-1 57 57 0 0112-5c4-1 9-2 13-5v1 6a20 20 0 011 4 8 8 0 000 1c1 2 1 4-2 5v-1-1h-1l-7 10-3 3-4 4-9 13c-1 2-2 5 1 7a128 128 0 0122 30 5 5 0 001 2h1a3 3 0 001 3 2 2 0 001 0l1 1h-1l1 1c0 2 0 5 4 5l1 1h-1c1 11 6 19 14 24a2 2 0 010 2 15 15 0 007 12 3 3 0 001 3l1 3-4 2a16 16 0 01-3 0c-6 0-8-5-10-9a34 34 0 00-2-4l-2-5c-11-18-23-38-36-56a3 3 0 00-2 0l-2 2c-3 4-2 4-1 6v2c1 4-3 6-6 8-4-11-6-24-5-39a172 172 0 000-26 2 2 0 00-1 0l-1 2-9 18-1 2-1 3a34 34 0 01-4 8c-5 6-2 12 1 18l1 2 1 3a124 124 0 007 14c5 7 8 16 12 23 3 7 6 15 10 21v1c2 4 5 8 1 13a7 7 0 01-4 2 3 3 0 01-1 0zm11-136c-5 0-8 3-9 8a6 6 0 01-2 4c-3 2-1 6 0 7a2 2 0 001 1l3-2a13 13 0 012-1 5 5 0 001-2 13 13 0 010-2 4 4 0 002-3l1-1a25 25 0 015-7l1-1-1-1a17 17 0 00-4 0zm-33 4l1 1a2 2 0 001 0 1 1 0 000-1h-2z"
      />
      <path
        style={styleOne}
        d="M238 168c1 2 1 3-3 4-11 2-11-8-15-13-12-21-24-42-38-61-2-2-3 0-4 2-3 4-3 4-1 7v1c0 4-3 6-6 8-5-13-5-26-4-39V53l-1-2c-2 0-2 1-3 2l-9 20-5 10c-6 8-2 15 2 22l8 16c9 14 13 30 21 44 3 4 6 8 2 13a7 7 0 01-4 3c-2 1-1-2-1-3l-10-20c-1-2-3-1-5-1v-5l-8-20c1-6-6-8-6-13l1-1-1-2c0-1 0-3-2-3l-2-3v-4h-1c-1 3-1 2-2 0a31 31 0 01-3-19l1-5c1 2 3 4 3 0v-6l3-7c1-1 2-1 1-2v-2l5-4c1-2 1-4-2-4a10 10 0 013-5l3-3 2 1v-1h-2v-4l1-2a7 7 0 012 1l1 2a2 2 0 002-1 3 3 0 00-2-3 2 2 0 00-3 1c-5 0-10 1-14-1-7-4-6 2-6 4 3 11-1 22 0 34l-1 3v23l-1 5c-3 2 0 4 1 5 0 1 2 1 2 3-4 1-1 6-4 8v12c-3 0-5-1-7 1 0-14 2-28-1-42 2-10 1-20 2-31 0-10-1-20 2-29 0-4 2-5 6-6 10-1 20 0 30 3 4 0 5 2 5 5 5 0 9 4 14 1 8-4 17-5 25-9-1 3 1 6 1 10 0 2 2 4-2 5 0-1 0-3-1-1l-10 12c-4 6-10 11-13 17-1 3-2 6 1 9a127 127 0 0122 30 10 10 0 002 1c0 2 0 3 2 3 1 3 1 7 5 7 1 11 5 20 14 26a2 2 0 010 1 15 15 0 007 12l1 4zM185 59a4 4 0 001-4l6-7c2-1 2-2 0-3-8-2-12 1-13 8a6 6 0 01-2 4c-3 2-1 6 0 8 2 2 4-2 6-3l2-3zM597 182a4 4 0 01-3-2c-3-3-6-7-4-14 1-2 0-4-1-5v-6-11-5a4 4 0 010-1v-2a1 1 0 00-1 0 5 5 0 00-1 0l-1-2c0-3 1-5 3-7a1 1 0 001-1l-1-1a5 5 0 01-1-2 8 8 0 00-1-1c-1-1-2-2-1-3l3-1 1-3v-3a35 35 0 001-3c-1-5-1-7-3-7l-6 2c-2 2-5 2-8 2h-1a5 5 0 01-1 0 2 2 0 01-2-1c-1-2 0-2 1-3a50 50 0 015-3h2c1-1 3-2 3-4s1-2 3-3a7 7 0 002 0c4-3 5-5 4-10a67 67 0 01-1-9l-1-12c-3-9 2-11 7-15l1-1a104 104 0 0112-6 109 109 0 0011-6l7-5 16-10 1-1 2-2c2 0 2 2 2 5 0 2 3 4 6 5l4 3-3 5c-3 0-6 1-8 4l-11 8c-7 3-14 8-23 14l-1 1a6 6 0 010 1c-3 1-5 3-5 6v15l1 2 1-1a7 7 0 011-2l4-1a11 11 0 001 0l2-1 1-2 3-1a48 48 0 006-3 9 9 0 014-1c3 0 5 1 8 3 2 1 2 2 2 4a4 4 0 000 2v1a2 2 0 01-1-1l-1 1v1h-1l-3 1-9 4a17 17 0 01-3 1l-6 2v1h-1a5 5 0 00-1 0c-1 4-3 6-6 8a21 21 0 00-4 3c-4 4-3 9-2 14a46 46 0 011 5c0 3 2 3 4 3a8 8 0 012 1 9 9 0 001 0c2 1 3 1 3 3l3 1h1a2 2 0 010 2v1h1l5 2v2c5 5 12 9 17 12h1l2 2a31 31 0 014 2 4 4 0 012 3 3 3 0 01-1 3 4 4 0 01-3 1 5 5 0 01-2 0l-23-11-8-4-1-1-1 1a12 12 0 01-3 4 17 17 0 00-2 3l-1 1v-1-1c-1-3-1-4-3-5l-2-3a4 4 0 00-1-2 27 27 0 010 6c0 4 0 7 2 10v1a3 3 0 00-1 1 3 3 0 001 3c1 1 2 3-1 5a3 3 0 00-1 4 17 17 0 011 6v3l-2 2z"
      />
      <path
        style={styleOne}
        d="M623 138l18 12a67 67 0 016 3c2 1 3 3 1 5-1 2-3 3-5 1l-31-14c0-1-1-2-2-1-1 4-4 5-6 8 0-3 0-6-3-6-3-1-1-4-3-5 1 5-1 11 2 16-2 2-2 3 0 5 1 2 2 3-1 5a4 4 0 00-1 4l1 9c-1 2-2 3-5 0-4-4-6-8-4-14 2-4-2-7-1-11v-16c0-1 1-4-2-3l-1-2c0-3 1-5 3-7 2-1 0-2-1-4s-5-5 1-5c2 0 2-2 2-3v-6c-1-8-2-9-9-5-3 2-6 2-9 2l-3-1c-1-2 0-2 1-3l6-3c1-1 4-1 4-4s4-2 5-3c4-3 5-5 4-10-1-7 0-15-2-21-3-9 3-12 8-16 8-4 16-7 23-12l23-15c2-1 5-6 5 2 0 2 3 5 6 6 5 1 5 2 1 7-3 0-6 1-8 4l-11 8a126 126 0 00-23 14l-1 1a6 6 0 010 1c-4 0-5 3-5 6v14c0 1-1 3 1 4l2-4 4-1c1 1 3 1 3-1l2-2a87 87 0 008-3c5-3 8-1 12 1s0 5 2 6c-2-1-2 0-3 2l-12 5c-3 1-7 0-9 3l-2 1c-1 6-7 7-10 11-5 6-2 13-2 19 1 5 5 3 7 4l4 3c0 2 2 2 4 2 0 1-2 3 1 3l5 2zM382 160c-1-3-3-2-6-2l-1-1-1-1v-4h-2c-2 0-3-2-4-4l-7-23-5-13a7 7 0 00-1-2 5 5 0 01-2-4c1-2 0-3-1-5a12 12 0 01-1-5v-1c3-1 2-3 1-5l-1-1v-1l-2-3a1 1 0 00-1 0 2 2 0 00-1 1c0 2 0 4 2 5v16c-2 2-2 4 0 6h-1c-1-2-2-4 0-7v-7-7c-1-2-2-4-1-6a2 2 0 011-1 1 1 0 011 0l2 3 1 1v1c1 2 2 4 0 6a12 12 0 001 5 11 11 0 011 5 5 5 0 001 3 7 7 0 012 3l4 13 8 23c0 2 1 3 3 3a3 3 0 012 1v4l1 1 1 1c3-1 5-1 6 2a2 2 0 001-2c-1-5-1-10 4-14a4 4 0 002-2 5 5 0 00-2-4 4 4 0 01-1-3 3 3 0 011-2v-1a7 7 0 01-1-3l-1-5-1-5-1-19V87v-3a18 18 0 010-7l-2-1 1-2a4 4 0 010-1 10 10 0 000-5c-1-2-2-5 1-8a6 6 0 00-3-4l-1-2 3-2-1-2-1-1-1-3c4-5 3-11 2-16a55 55 0 01-1-6 20 20 0 010-6v-8a19 19 0 01-1-3l-2-4c-3-1-6 0-8 2a5 5 0 00-1 4 91 91 0 011 16 279 279 0 002 34l1 13v4l1 15-2 5-3-3c-1-5-3-9-6-13s-6-9-7-15a112 112 0 00-5-14l-4-12a18 18 0 00-7-9 4 4 0 00-2 4 43 43 0 010 11l1 13v29a36 36 0 011 17v7a27 27 0 011 13v4l1 10v4l1 14a9 9 0 012 0 9 9 0 001 0v-1-1a1 1 0 01-1-1h1v-1-2-4c-2-4 0-6 2-9a20 20 0 002-3 3 3 0 000-1 4 4 0 010-1v-5a63 63 0 010-5 1 1 0 000-1v3l1 3v5a3 3 0 000 1 4 4 0 010 1 20 20 0 01-3 3c-2 3-4 5-2 9v11a10 10 0 01-1 0 10 10 0 00-2 0l-2-14 1-5-1-10-1-4a27 27 0 000-13v-7a36 36 0 00-1-17l-1-28 1-1-1-13a42 42 0 000-11c-1-2 0-4 2-5a18 18 0 017 10l4 11a112 112 0 015 15l7 15 7 12c0 2 1 3 2 3l1-4V76l-1-4V59a2411 2411 0 01-2-34 90 90 0 00-2-16 5 5 0 012-5c2-1 5-2 9-1l2 4a18 18 0 000 3c2 3 1 6 0 8a20 20 0 000 6 55 55 0 001 6c1 5 2 11-2 17l1 1 1 1 2 3-4 3a5 5 0 002 0 6 6 0 012 4 2 2 0 010 2c-2 2-2 5-1 7a11 11 0 010 5 4 4 0 001 1 4 4 0 010 1l-1 1h2v1l-1 7v3l1 13v19l1 5 1 4v1a6 6 0 001 3v2a3 3 0 00-1 1 4 4 0 002 3 6 6 0 011 4 4 4 0 01-2 3c-4 3-4 8-4 13l-1 2z"
      />
      <path
        style={styleOne}
        d="M349 121v6l1 5v2c-3 4-8 7-5 12v11l-3-1-1-14c-1-4 1-10-1-14v-4a27 27 0 00-1-13v-7a36 36 0 00-1-17l-1-27c1-1 2-1 1-2-2-8 1-16-1-24-1-2 0-3 2-5a18 18 0 017 10l9 26c3 11 11 18 14 27 0 2 1 4 2 3l2-4-1-19-3-42-1-21c-1-4 4-7 10-6l2 7c2 5-1 9 0 14 1 8 5 15-1 22l1 2c1 2 5 4-1 6l1 2 3 4c-4 5 0 9-1 13l1 2c-2 1-1 1 0 2v10l1 32c2 3 0 7 2 10l1 4c-2 2-1 3 0 5 2 2 3 5 0 6-4 4-4 9-4 14l-1 2c-1-3-4-3-6-2l-2-2c1-4 0-5-2-5s-3-1-4-3l-11-36c-1-2-3-3-3-6 0-4-3-7-2-10 2-3 0-5-1-7-1-1-1-5-3-4s-1 4 0 7v15c-2 2-1 4 1 6M510 163a5 5 0 01-2 0c-3-2-6-6-5-9 0-6-1-12-3-17a10 10 0 010-2 6 6 0 00-1-4v-2a11 11 0 00-1-2l-2-5-5-11c0-3-2-6-6-6a7 7 0 00-1 0l5-13c1 0 3 0 3 2l1 2a50 50 0 002 6l1 3c2 4 4 8 9 8a132 132 0 015 20 6 6 0 003 4 1 1 0 001 0l2-2 5-7 2-3 1-1c-2-6-1-12 0-17 1-10 1-19-2-27v-3l1-4a4 4 0 00-3-2c-3 0-2-2-2-4a8 8 0 010-1v-3a1 1 0 00-1 0l-1 1a3 3 0 01-1 2l-6 7-1 1-1 4-4 1v6a10 10 0 00-1 3c-1 3 0 4 2 5h1a6 6 0 01-2 3l-1 1a5 5 0 010-1l-6-2c-1-2 0-3 2-7l1-3a2 2 0 000-1 1 1 0 00-1-1 7 7 0 00-1 0h-1a5 5 0 01-2 4c-2 1-3 2-2 4a1 1 0 010 1l-3 1a1 1 0 010-1v-3a1 1 0 00-1-1 8 8 0 00-1 1 8 8 0 01-2 0 1 1 0 01-1 0c0-12 8-18 15-24l3-3 1-2c-1-6 3-9 7-11h1v-1l1 4a2 2 0 001 0 3 3 0 001-3 3 3 0 00-2-1v-1a2 2 0 012-2c4-1 3-3 3-5a9 9 0 01-1-4h1a5 5 0 012 1 4 4 0 003 2 3 3 0 002-2l1-1a15 15 0 011-1 7 7 0 002-2l2-1a2 2 0 011 0l1 1c2 2 4 4 1 7a19 19 0 00-1 3l-3 4c-2 2-3 4-1 7 2 5 2 11 3 16v6l1 8 4 21a18 18 0 011 6 29 29 0 001 3 29 29 0 003 8l1 1c2 5-1 12-8 16l-10 8-5 4-1 4a7 7 0 010 2c-1 4-4 7-8 7z"
      />
      <path
        style={styleOne}
        d="M513 46a2 2 0 011-1c6-2 2-7 3-10v1-1c2 0 4 5 7 1a28 28 0 013-2c1-1 2-5 4-3 1 2 5 4 2 8-1 2-2 6-4 7-3 2-3 5-2 7 4 7 3 15 4 22 1 10 1 20 5 29l1 9 4 9c3 5-1 12-7 16-6 3-10 8-15 12-2 2-1 4-1 6-1 4-6 8-10 6-3-1-5-5-5-8 1-6-1-12-3-17 0-2 1-4-1-6a20 20 0 00-1-4c-2-6-6-10-7-16 0-3-2-7-7-6l5-12c1 0 2-1 3 1l3 8c2 5 3 11 10 12a132 132 0 015 19 6 6 0 003 4c2 1 3-1 3-2l7-9 1-2c-2-6-1-11 0-17 1-9 1-19-2-27v-2c2-3 2-6-2-7-2-1-2-2-2-4 0-1 2-3 0-4s-2 2-3 3l-6 7-1 1-1 4c-2-1-4 0-4 1 1 4-1 6-2 9 0 3 1 4 3 5l-2 4v-2c-7 0-7-1-4-7l1-4v-2h-3c-1 4-6 4-4 8l-3 2v-1c2-7-3-2-5-3 0-13 10-19 18-27 1 0 2-1 1-2-1-7 4-9 8-11v4l2-1c1-2 2-3 0-5zM73 180a2 2 0 00-1 0 6 6 0 00-2 0 6 6 0 01-1 0 2 2 0 01-2-1l-3-1a4 4 0 00-1 0v-1a38 38 0 010-4 19 19 0 001-6 151 151 0 01-2-17l-3-22a14 14 0 010-5c0-3 0-6-3-8v-8a49 49 0 000-12 49 49 0 010-12 10 10 0 000-3v-1c0-2-2-5-4-5a3 3 0 00-1 0 2 2 0 00-1 1l-1 4c-2 2-2 4-2 7a11 11 0 01-1 5l-8 18a7 7 0 00-2 6 2 2 0 01-1 0 6 6 0 01-2-2l-4-2v-1-1l-1-4a4 4 0 00-3-1 2 2 0 01-2-1 2 2 0 010-2c2-2 1-5 0-7s-1-5 0-7a3 3 0 000-1 4 4 0 01-2 0 3 3 0 01-2 0 3 3 0 010-3c0-2 2-3 4-3h1l1 1a3 3 0 000 1 3 3 0 001 2 7 7 0 011 1h1l-1 1v3a9 9 0 011 2l2-6a6 6 0 010-1v-4l1-2c4-5 6-11 8-16a1 1 0 010-1c3-1 4-4 5-7a13 13 0 005-12v-1c2 0 2-2 2-4a1 1 0 010-1 3 3 0 002-1 2 2 0 000-2h1c2 0 2-2 2-3a6 6 0 011-3v-1h1v-1a8 8 0 003-3c1-2 2-4 4-4a7 7 0 012 0v1a34 34 0 01-1 4l-1 8v1c-2 8-2 14 0 19v6l1 3v7a25 25 0 010 3l1 18 1 20v14c0 1-1 5 2 6v1l1 10a39 39 0 000 5v9a72 72 0 002 24 4 4 0 011 3z"
      />
      <path
        style={styleOne}
        d="M51 37c2-1 3-2 3-4 3 0 2-4 3-5v-2h1v-1c3-1 3-8 9-6-1 4-3 8-2 13-2 6-3 13 0 20v5l1 3c-2 3 0 6 0 10l2 38v14c-1 1-1 5 1 7 3 4 1 10 1 15 1 10 0 21 3 32l1 4c-2-2-5 2-7-1l-4-2 1-10c-3-13-2-26-5-39-1-4 3-10-3-13v-8c1-8-1-16 1-24a12 12 0 000-4c-1-2-3-5-5-5-3 0-3 3-3 5-4 3-1 8-3 11l-8 18a7 7 0 00-2 7 2 2 0 01-1 0c-2-1-3-5-6-5 0-2 1-6-4-6a2 2 0 01-2-3c3-5-3-10 1-14l-1-1c-3 1-4-1-4-3s3-2 5-2h1a3 3 0 000 1l2 3c-2 3 1 5 1 7l2-7c0-1 2-3 1-5v-1c4-5 6-11 8-17 3-2 4-5 5-8a13 13 0 005-13c2 0 2-2 2-4zM446 174l-1-1 1-5c2-10 2-18-2-24v-3a1 1 0 001 0 1 1 0 00-1-1l-1-1v-1l-3-4v-1a34 34 0 00-1-16 23 23 0 01-1-6c0-3 0-6-2-9l-1-4v-1h2l-2-1v-3l-1-5-1-1v-4l-1-3v-1l-1-4v-3l-1-3v-1l-1-1c-3-1-4-3-4-4 0-2 2-4 4-6l14-15c11-12 23-23 36-33a7 7 0 001-1l2-1a1 1 0 010 1 3 3 0 003 1l2-1a7 7 0 011-2 5 5 0 002-1l2-2a3 3 0 012 1 6 6 0 012 5 6 6 0 01-3 4c-2 2-2 4-2 6v1l-4 2a40 40 0 00-12 8l-1 1a5 5 0 01-3 2c-6 1-10 5-12 8a110 110 0 01-20 19h-1c-1 1-2 1-1 3l3 9 1 4 2 19v2l-1 1 1-1 3 6a18 18 0 000 2 88 88 0 012 9l4 14v2a54 54 0 002 8l2 13v1a4 4 0 01-1 3c-2 1-2 2-1 3a2 2 0 001 1 4 4 0 002-1l15-10 5-3 1-1a17 17 0 003-2 4 4 0 013-1 2 2 0 011 1 5 5 0 012 5c-1 4-4 6-7 7a29 29 0 00-3 2l-7 5a138 138 0 00-16 13v1h-1-1a7 7 0 00-2-1 2 2 0 00-2 1z"
      />
      <path
        style={styleOne}
        d="M433 83l-1-3v-1-4l-1-3v-3a1 1 0 00-1-1l-1-1c-6-4-4-7 0-10 17-16 31-34 50-48 1 0 2-2 3-1 3 3 5 0 6-1 2-1 3-6 6-2 3 2 2 6-1 8-2 2-2 4-2 7v-1l-4 2a40 40 0 00-13 9 6 6 0 01-3 2c-5 1-9 5-12 9a110 110 0 01-20 19c-1 0-3 1-2 3l4 13 2 19v1c-1 1-2 1-1 2h1c2 2 2 5 3 7 2 8 3 16 6 23v2c1 7 4 14 3 21 0 1 1 3-1 4-1 1-2 2 0 3h3l20-13a30 30 0 004-2c1-2 3-2 4-1a5 5 0 012 5c-1 5-7 6-10 9-8 6-16 11-23 18l-1 1c-2-1-3-2-5 0l-2-1-1-1 1-5c2-8 3-17-2-24v-2a1 1 0 000-2l-1-1c0-2 0-4-2-6h-1a34 34 0 00-1-16c-1-5 1-10-3-15l-1-4c2-1 2-2 0-2v-2-1l-1-5-1-1v-3-1zM315 148l-4-2a20 20 0 00-3-2c-3-2-6-5-4-10a12 12 0 00-1-7c-3-5-4-11-5-17l-1-3-1-14a77 77 0 00-5-21 53 53 0 01-3-11l-1-7 4-7 2-2 10-12 4-4a2 2 0 011-1l6 7 1 3c-3 3-2 6 0 8a22 22 0 012 9v1a1 1 0 00-1 0 1 1 0 000 1h1a8 8 0 010 3c0 2 0 3 2 4v1a18 18 0 002 7 23 23 0 011 6c-1 2-2 4 1 5v1l2 12 1 1a2 2 0 001 0c4 0 3 3 3 5a9 9 0 000 3h-1l-2 1a1 1 0 000 1 2 2 0 002 0l-1 3h-2a1 1 0 000 1l1 1a3 3 0 001 0 3 3 0 011-1h1v1l-1 3a11 11 0 00-1 2 4 4 0 00-3-1c-1 0-2 1-2 3a19 19 0 01-1 3l-1 6 1 4h-1a3 3 0 00-2 1 2 2 0 000 2 1 1 0 010 1 9 9 0 011 6l-1 2c0 2-2 4-4 4zm-11-98a2 2 0 00-1 0c-2 1-3 3-3 5a5 5 0 00-1 2 83 83 0 011 10c1 6 1 12 4 18a16 16 0 012 5 61 61 0 010 6c1 6 1 12 6 17l1 1a2 2 0 001 0l1-1 1-3v-3l1-2c2 0 2-1 2-2v-1-4l-8-31a10 10 0 00-2-5v-1l-1-2a27 27 0 00-2-5 6 6 0 01-1-2l-1-2z"
      />
      <path
        style={styleOne}
        d="M323 84l2 12c0 1 1 2 2 1 5 1 2 5 3 8-1 0-2-1-3 1l2 2-1 1-2 2c1 2 2 1 4 1l-2 5c-3-3-5 0-6 2 0 3-2 6-1 9v3c-2 1-3 2-2 4a1 1 0 010 1v1a8 8 0 010 5v2c-1 4-4 6-8 2-3-3-10-5-7-12a12 12 0 00-1-8c-4-5-4-12-6-19l-1-14a77 77 0 00-5-21l-4-18c0-3 4-6 7-9l13-16 1-1c1 0 7 8 6 10-2 3-1 6 1 8a22 22 0 012 9l-2 2h2c1 3-2 6 2 8l3 13c-1 2-2 4 1 6zm-4 18v-2l1-2-9-31a10 10 0 00-2-6l-3-7c-1-2-1-4-3-4l-4 5a5 5 0 000 2c2 9 0 19 5 28a16 16 0 012 5c1 8-1 16 6 23 1 2 2 1 3 1 2-2 1-4 1-5l1-4c2 0 2-1 2-3zM93 160v-1a7 7 0 00-1-3 12 12 0 01-1-2c0-2-1-3-2-3a4 4 0 00-1 0h-1a14 14 0 00-2-15c-1-1-2-2 0-4v-1a9 9 0 00-1-3 88 88 0 01-5-21v-1l2-1-2-2a3 3 0 00-1 0l-2-1c1-3 0-6-1-8-2-2-3-5-2-7v-1-3a4 4 0 01-1-3 17 17 0 012-6l2-6v-1l3-6c2-3 5-7 6-11v-1a2 2 0 001 0 3 3 0 001-2l1-2v-1c2 0 3-1 3-3v-1c2 0 2-2 2-3a6 6 0 011-3h1c2 0 4 0 4-2l2-2h1c1 0 0 0 0 0a2 2 0 001 0v1a2 2 0 001 0 12 12 0 014-1c3 0 4 2 5 7a12 12 0 010 3v2l1 2 1 2a28 28 0 011 6 23 23 0 001 8 56 56 0 014 16v3l1 18v2c1 6 1 12-3 18a15 15 0 01-3 2c-1 1-3 3-3 5a3 3 0 01-1 2 2 2 0 01-1 1h-1-1v-1l2-3 4-8c4-4 4-8 4-12l-1-3v-3l-1-5-2-19-2-8v-1a6 6 0 01-1-1 2 2 0 010-1v-2a2 2 0 00-1 0h-2v2c-1 2-2 4 0 5l2 3v3a3 3 0 00-1 3 3 3 0 002 1v1a3 3 0 000 3v1c-2 5-1 8 1 11l2 4 1 1 1 1v4l-1 2-2 2a4 4 0 01-2-1 5 5 0 00-1 2v1a5 5 0 001 0 4 4 0 011 0l1 2a4 4 0 000 1v1h-1a2 2 0 00-2 1 2 2 0 00-1 0l-1 2a8 8 0 010 2v3l-1 1a5 5 0 01-1 0 6 6 0 01-4 1 13 13 0 01-3 0h-1v-1h1a5 5 0 00-1-1 1 1 0 011-1l1-1a1 1 0 01-1 0 1 1 0 011-1 1 1 0 001-1v-1l1-1v-1a1 1 0 000-1v-1h1l1-2v-2c2 0 2-1 2-2v-1h1l-1-1a2 2 0 010-3 8 8 0 002 1 1 1 0 000-1 3 3 0 001-2 113 113 0 00-3-11l-3-17c0-1 0-3-2-3v-3-1h-1v-4c2-3 1-5-1-6v-3c1 0 2 0 2-2l-2-1v-1l-1-2a3 3 0 00-1 1 4 4 0 01-1 0 1 1 0 01-1 0 5 5 0 00-1 3 9 9 0 010 2 2 2 0 00-1 1 2 2 0 001 1c1 2 0 3-1 4l-1 2v1a62 62 0 01-3 7c-3 4-6 9-6 15l-1 1h1v3l-2 2 2 1v3l-2 6a5 5 0 001-1 3 3 0 012-1 2 2 0 011 0v4l-1 6-1 8a5 5 0 011 0c2 0 2 2 2 3a7 7 0 000 2l2 8 2 8c0 2 1 4 3 4l3 1-1 3c-2 2-1 3-1 5l1 1a2 2 0 001 1 1 1 0 001-1 40 40 0 014-8 46 46 0 003-8 7 7 0 002-3 10 10 0 012-3l2 3a2 2 0 01-1 1c-2 2-3 5-3 7a17 17 0 01-3 6 25 25 0 00-4 7c-1 4-2 7-6 10zm-8-39h1a1 1 0 00-1-1 2 2 0 000 1zm-6-40a1 1 0 00-1 1v3l1 2v-6zm-3 4a1 1 0 000 1 1 1 0 000-1zm4-7a3 3 0 000-1 2 2 0 000 1z"
      />
      <path
        style={styleOne}
        d="M87 47l1-2c2-1 3-2 3-4v-1c3-1 2-4 3-6 2 0 5 1 5-2 1-2 2-1 4-1h1c6-2 8 0 9 6a23 23 0 010 4l1 4 1 1c1 4 0 9 2 14a56 56 0 013 16l2 21c0 7 2 13-4 20-1 2-5 3-5 7 0 3-2 2-4 2 2-3 3-8 6-11 4-3 4-8 4-12l-1-3v-8c0-10-3-18-4-27l-2-2c0-1 2-2 0-3h-3c-1 3-2 5 0 8l2 2c1 3-4 6 1 7v1l-1 3v1c-1 4-1 8 1 11l3 4a2 2 0 001 2h1v4c-2 0-1 6-5 3a4 4 0 00-1 2c-1 2 0 1 1 1 3 0 2 1 2 3l-3 2a3 3 0 00-1 0l-1 4a4 4 0 000 1v2l-1 1a5 5 0 01-1 0h-7a9 9 0 000-1l1-2a2 2 0 001-2v-1a1 1 0 001-1v-1a1 1 0 001-1v-1l1-3c2-1 2-2 2-3v-1-1a1 1 0 010-2c2 0 3 0 3-3-1-9-5-18-5-28l-3-4v-1c1-2 0-2-1-3v-2c2-3 2-6-1-7v-2c1-1 3-1 3-3l-3-2c0-4-3 0-4-2-2 2-1 4-1 6v3c1 2-3 3-2 6-3 7-9 13-9 22l-2 1 2 1v1c-3 2-3 3 0 5v2l-3 6c2 0 3-2 5-1v3c-2 4 0 9-3 14l1 1c4-1 3 2 3 4l4 16c0 1 0 4 3 4 3 1 4 1 1 4v6c1 2 3 2 3 0l7-15 4-7c2 1 3 3 1 4-4 4-3 9-6 13-4 5-4 13-10 16h-1l-2-6c0-2-1-4-3-3h-1a14 14 0 00-1-15c-1-1-3-2-1-3l-1-5-5-21v-1c3-1 3-2 0-3-1-1-3 0-2-1 1-6-5-10-4-15v-1c3-2-1-3-1-6 0-4 4-8 4-12v-1c3-5 7-11 9-17 2-1 2-2 2-3zm-8 41v-7a2 2 0 00-1 1c-1 1 0 3 1 6zm6 33h1l-1-1a3 3 0 00-1 1zm-9-36l-1 1a1 1 0 001 0 1 1 0 000-1zm5-8h-1a3 3 0 000 1 4 4 0 001-1zM255 145c-5-3-4-7-2-10v-1l2-4c1-3 3-5 3-8v-1l1-2 1-3v-1l4-7v-1l1-1v-1a36 36 0 006-8l2-3c3-5 1-7-2-9l-2-1a5 5 0 00-3-2c-7-3-10-9-13-13l-3-5-3 4v1l-6-6a3 3 0 00-1-3l-2-1a10 10 0 01-2 0l-1-2a39 39 0 00-3-8v-5a4 4 0 013-2 6 6 0 011 0 198 198 0 0117-19 18 18 0 005-9c0-1 0-3 2-3a4 4 0 012 1l1 1a17 17 0 015 3l2 4-3 2-2 2a2 2 0 000 2c1 2 0 3-1 5a12 12 0 00-1 1l-3-2-3 3a5 5 0 01-2 1l-1 1c-3 0-4 2-4 4v1c-4 1-6 4-8 6l-2 3a1 1 0 000 1l1 1 2 3v1a3 3 0 010 1v2a7 7 0 012 1 6 6 0 003 0 2 2 0 002-1v-1h2l2 2c10 8 21 17 34 22 2 1 2 2 2 5 0 11-6 19-11 27l-6 10-3 5a38 38 0 00-5 7c-2 5-6 8-10 10z"
      />
      <path
        style={styleOne}
        d="M236 42a198 198 0 0117-18 18 18 0 005-10c0-3 1-3 4-2l6 4c1 2 3 5-1 6-2 1-3 2-2 4 1 3-1 4-2 6-2-3-4-3-6 0l-3 3c-3 0-4 2-4 4v1c-5 1-7 5-10 9-2 2 3 2 3 5v1c0 1-2 3 0 3s5 3 7 0h1c12 8 23 18 37 23 2 1 2 2 2 5 0 15-11 25-17 37l-8 12c-2 5-6 7-10 10-5-3-3-7-1-11 1-4 4-8 4-12l1-3 1-3 1-1 3-7 1-1v-2c4-3 6-8 8-11 3-5 1-7-2-9l-2-1a5 5 0 00-3-3c-6-2-10-7-12-12-3-6-5-7-7-1l-6-5c1-5-3-4-5-4l-4-10c-2-4 0-7 4-7zM566 154h-2-1a3 3 0 00-3-1 8 8 0 01-1 0 7 7 0 01-5-3 7 7 0 01-1-6v-1l1-2 3-7a2 2 0 000-1 6 6 0 01-2 0 1 1 0 01-1 0l1-3a2 2 0 000-2 1 1 0 00-1 0h-2a3 3 0 010-1v-1a2 2 0 003-1 2 2 0 00-1-1 8 8 0 01-1-5 13 13 0 000-3 39 39 0 010-6c0-3 0-7-2-10v-3l1-1c-2-9-2-19-1-28v-9-14a1099 1099 0 011-27 9 9 0 007 0v1a17 17 0 011 6 3 3 0 001 3 2 2 0 001 0l1 3v2a2 2 0 00-1 1 2 2 0 001 2l1 7v21c0 2 0 5-3 6l-1 2a8 8 0 010 1l1 19a63 63 0 010 12v14l1 1c0 4 1 7-1 9s-2 5-1 7l1 2 1 1a7 7 0 002 0 8 8 0 012-1 2 2 0 011 0l4-1a2 2 0 002 1 6 6 0 001 0 6 6 0 013-1 2 2 0 011 1 3 3 0 003 1 2 2 0 001 0v-1 1a16 16 0 000 2c0 3 0 5-4 6a2 2 0 000 1l-1 4a3 3 0 01-2 1h-1a7 7 0 00-2 0l-1-1-2 1v1a5 5 0 01-3 1zm-8-31v-1a1 1 0 000 1z"
      />
      <path
        style={styleOne}
        d="M582 138c0 3 1 7-4 8a2 2 0 00-1 2c2 5-3 3-5 4-2-2-2-1-3 1h-10c-5-1-7-5-6-9l5-10-1-2c-5 3-2-2-2-2 1-3-1-2-2-2a5 5 0 01-1-1c2 0 4-2 2-3l-1-8c-1-5 1-11-2-16v-2l1-2c-2-12-1-25-1-37l1-29c-1-4-3-8 0-11a9 9 0 007 0 17 17 0 011 6c0 1-1 3 2 4l1 2v1a2 2 0 00-1 4c3 3 2 6 2 9v17c0 3 1 7-3 8l-1 3c-1 6 0 13 1 19 1 9-2 18 0 26 1 3 2 8 0 9-3 4-1 7 0 10 0 3 4 0 6 0h4c2 2 5-2 7 0s3 2 4 1zm-23-16h-1l-1 1h1l1-1zM10 164l-1-1a8 8 0 000-1 8 8 0 010-2c0-3 0-4-4-4v-3l2-1-2-1v-2 2l2 1-1 2v1c3 0 3 3 3 4a8 8 0 000 3 8 8 0 011 1v1l1-1a5 5 0 011-1l1-7a27 27 0 010-3 532 532 0 002-54l-1-1c-1 0-2-1-1-2a3 3 0 011-2 2 2 0 001-2 5 5 0 00-2-3c-3-3-3-6-3-9a26 26 0 00-1-4 2 2 0 011-2h1c0 2 2 2 3 2 2 1 4 1 4 3l1 1h2a4 4 0 013-1v-1l-3-1 1-2 1-1a2 2 0 01-1-2c-4-2-5-4-5-7 0-2-1-3-3-5l-2-5a25 25 0 00-2-7l-1-3c-1-2-3-5-6-4-2 1-1 3-1 5v1l1 2v11c2 3 1 6 0 8v8c2 6 1 12 1 18l-1 8a24 24 0 000 4c1 3 1 6-1 9l1 3v3c1 9 3 19 2 29H4c1-10 0-20-1-29l-1-3v-4c2-2 1-5 1-8a25 25 0 010-4v-8-26c1-2 1-5-1-7v-3-8-3-1c-1-2-1-5 1-5 3-1 5 2 6 4l1 3a26 26 0 012 7c0 2 1 3 3 5l2 5c0 3 2 5 5 6v1a2 2 0 001 1v3l-1 1 2 1v2h-3l-2 1a2 2 0 01-1-1c-1-3-2-3-4-3l-4-2a1 1 0 000 1 26 26 0 010 4c1 3 1 6 3 8a5 5 0 012 4 3 3 0 01-1 2 3 3 0 00-1 2l1 2 1 1v11l-1 43a27 27 0 000 3c0 2 0 5-2 7a4 4 0 000 1l-2 1z"
      />
      <path
        style={styleOne}
        d="M5 149c1-11-1-22-3-32v-4c3-3 1-8 1-12 0-9 2-17 0-26v-8c1-2 2-5 0-7l-1-2c2-4 0-8 0-12 0-2-1-6 1-6 3-1 5 2 6 4l3 10c0 4 5 6 5 10s2 5 5 6v1a2 2 0 001 2c0 1-4 3 1 4v1c-2-1-5 4-6 1-1-5-6-2-8-6l-1 2c2 4 1 9 4 13 1 1 3 3 1 5-3 2 0 3 1 5l-1 54c-1 3 0 7-2 10l-2 2-1-2c-1-3 1-6-4-6v-2c3-2 1-3 0-3v-2M226 122h-1c-4-1-6-3-6-7a13 13 0 00-1-4l-1-1v-7a415 415 0 01-1-55l-1-14a4 4 0 011-4c1-1 1-2-1-3-1-6 0-9 4-12 3 4 6 9 7 14a25 25 0 010 6c-1 4-2 8 1 12-2 2-2 4-2 6a14 14 0 010 3c-1 11 0 22 1 33l2 15v3a2 2 0 000 2 6 6 0 011 3 5 5 0 001 4h1c-1 4-2 6-5 6z"
      />
      <path
        style={styleOne}
        d="M216 27c-1-5-1-9 3-12 3 4 6 9 7 14 0 6-3 12 1 18-4 2-2 6-2 9-2 16 2 32 3 48v3a2 2 0 000 3c1 1 0 4 2 6 0 3-1 6-5 5-3 0-6-1-6-6l-1-5-2-20V48a55 55 0 00-1-14c-1-3 4-5 1-7z"
      />
      <path
        style={styleTwo}
        d="M391 118a14 14 0 00-3-5 12 12 0 01-2-5l-1-20a143 143 0 00-1-15V63a10 10 0 010-1 3 3 0 001-2l-1-17-1-10V23a177 177 0 00-2-22 16 16 0 013-1c4 0 4 2 5 7a89 89 0 001 11v8l1 2a653 653 0 012 71 11 11 0 010 4c-1 2-1 4 1 6-2 1-2 2-1 4 0 2 0 4-2 5z"
      />
      <path
        style={styleTwo}
        d="M381 1c6-2 7 0 7 6l2 19 2 43 1 30c0 4-2 7 1 10-4 2 1 7-3 9l-5-10c-2-11-1-23-2-35l1-2v-6l-1-2 1-3c-2-9-1-18-1-27l-3-32z"
      />
      <path
        style={styleThree}
        d="M342 184a8 8 0 01-1 0c-2-1-2-3-2-4v-1l-2-16-2-21-1-22V52a8 8 0 012 4 7 7 0 002 3v32l1 12v8l1 13v4l1 14 1 15a8 8 0 011 1 4 4 0 001 3c2 5 1 11 1 16 0 2 0 3 2 3v1a5 5 0 01-5 3z"
      />
      <path
        style={styleThree}
        d="M341 143l1 14 2 4c2 5 1 11 1 16 0 2 0 3 2 4-1 2-4 3-6 2s-2-2-2-4c-1-12-3-24-3-37l-2-37V53c2 2 1 5 4 7v27l1 16v8l1 13v4l1 15z"
      />
      <path
        style={styleTwo}
        d="M455 159a2 2 0 01-2-1c-1-1 0-2 1-3a4 4 0 001-3v-1l3-2c1-1 0-3-1-4a16 16 0 010-2c-3-7-3-15-4-22v-4a121 121 0 00-2-13 91 91 0 01-2-16v-1c0-2-1-4 2-5 5 9 6 18 7 27v1l2 13 2 17 1 2a6 6 0 002-1h1a16 16 0 014-1c4 0 6 2 7 5l-5 4-15 9a5 5 0 01-2 1z"
      />
      <path
        style={styleTwo}
        d="M477 145l-20 13h-3c-2-1-1-2 0-3 2-1 1-3 1-4 6-2 3-5 2-8-3-8-3-17-4-26-1-10-4-19-4-29 0-2-1-4 2-5 5 8 6 17 7 27l3 30c1 3 3 2 5 1 5-1 9-1 11 4zM442 77a7 7 0 01-1 0l-1-4-4-10c0-2 1-3 2-3l1-1a110 110 0 0019-18c3-4 7-8 13-9a5 5 0 003-2 40 40 0 0113-9c3 5 2 8-3 11a17 17 0 00-5 4l-1 3h-1c-4 0-6 2-9 5a37 37 0 01-3 2c-6 5-11 10-15 16l-3 4h-1a3 3 0 00-2 1 4 4 0 000 2 5 5 0 010 3 6 6 0 000 2 3 3 0 010 2 2 2 0 01-2 1z"
      />
      <path
        style={styleTwo}
        d="M441 76l-4-13c-1-2 1-3 2-3a110 110 0 0020-19c3-4 7-8 12-9a6 6 0 003-2 40 40 0 0113-9c2 5 1 8-3 11-3 1-4 4-7 7-5 0-8 4-13 7-7 5-12 13-18 20-4 0-1 4-2 6 0 2 1 5-3 4zM347 181c-2-1-2-2-2-4l-1-16 1-4v-11c6-1 5-5 5-9a30 30 0 01-1-4v-12l-1-5v-3-22c2 0 2 2 3 3a4 4 0 001 1v1a12 12 0 001 5 11 11 0 011 5c-2 5-1 10-1 15v3l1 22 1 9a81 81 0 010 10 85 85 0 000 10c0 3-3 5-8 6z"
      />
      <path
        style={styleTwo}
        d="M347 181c-2-1-2-2-2-4 0-5 1-11-1-16 2-1 1-3 1-4v-4-7c7-2 5-8 5-13l-1-5h1a5 5 0 00-1-1v-5-5-1-3l-1-6V92c3 0 2 3 4 4-1 3 3 6 2 10-2 6-1 12-1 18l2 31-1 20c1 4-4 5-7 6z"
      />
      <path
        style={styleFour}
        d="M562 138l-2-1v-2c-1-2-2-5 1-8 2-1 1-5 0-7v-2l-1-14a62 62 0 000-12V73a7 7 0 000-1l1-2c3-1 3-4 3-6v-2a686 686 0 00-2-26 2 2 0 010-2 3 3 0 011-2l6 2 1 8c-3 3-2 6 0 8v10h-1l-1 2-1 15-1 22-1 9v18a11 11 0 002 7v5a2 2 0 00-1 0 7 7 0 00-2 0 7 7 0 01-2 0zm6-83h-1z"
      />
      <path
        style={styleFour}
        d="M567 137c-2 0-6 3-6 0-1-3-3-6 0-10 2-1 1-6 0-9-2-8 1-17 0-26-1-6-2-13-1-19l1-3c4-1 3-5 3-8V45c0-3 1-6-2-9a2 2 0 011-4c6 1 7 2 7 10-4 2-2 5 0 8v9c-2 0-3 1-3 3l-1 37c-1 9-3 18-1 27a11 11 0 002 8zm1-82h-1l1 1z"
      />
      <path
        style={styleThree}
        d="M217 110a6 6 0 01-5-2 5 5 0 01-1-4 71 71 0 00-1-13 86 86 0 01-1-11V57l-1-10c2-1 2-2 2-4a8 8 0 010-1 20 20 0 00-1-4v-7c3 0 4-2 6-4l1-1c2 2 1 3 0 5a4 4 0 00-1 2l1 15v42l1 13 1 7h-1z"
      />
      <path
        style={styleThree}
        d="M216 27c3 2-2 4-1 7a55 55 0 011 14v42l2 20c-4 0-7-2-7-6 1-8-1-16-1-24l-2-33c4-1 2-3 2-5 0-4-2-7-1-10 3 0 5-3 7-5zM609 81c-2-6-2-11 2-16h2l1-1h1c4-2 8-4 9-8l2-3h1c4 0 6-2 9-4a23 23 0 015-3l5-5c2-2 4-4 8-5-1 7-5 11-10 14a59 59 0 00-4 4l-6 5a80 80 0 00-6 6l-7 6a6 6 0 00-3 6l-2 2a3 3 0 00-3 2h-4z"
      />
      <path
        style={styleThree}
        d="M618 77l-2 2a3 3 0 00-3 1l-4 1c-1-5-2-11 2-15l2-1h1c4-2 9-4 10-9l2-3c7 1 10-5 15-7s7-9 13-10c-1 9-9 13-14 18l-12 11-7 5a6 6 0 00-3 7z"
      />
      <path
        style={styleTwo}
        d="M58 184c-2 0-3-1-3-4a358 358 0 01-4-56 211 211 0 00-1-27v-4h1c1 4 3 7 2 12a1 1 0 000 1h3v9c-2 5-1 10-1 15l1 4 2 42c0 3 1 5 4 6v1a7 7 0 01-4 1z"
      />
      <path
        style={styleTwo}
        d="M56 107v8c-3 6-1 13 0 19l2 42c0 3 0 5 4 7-4 2-6 2-7-4a356 356 0 01-4-55l-1-26c0-1-1-3 1-4 1 3 3 7 2 11 0 1 1 2 3 2z"
      />
      <path
        style={styleFive}
        d="M228 104l-2-15c-1-11-3-22-1-33a13 13 0 000-3c-1-2-1-4 1-6-2-4-2-8-1-12a25 25 0 001-6c-1-5-4-10-7-14a12 12 0 015-1 4 4 0 012 1l2 6a7 7 0 002 6c4 4 6 9 6 15v1a6 6 0 00-1 0 4 4 0 00-3 1v5a39 39 0 014 8v4h-3l-1-1a8 8 0 00-1-2 4 4 0 01-1-1l-2-1-1 2a6 6 0 010 1v22l1 5v18z"
      />
      <path
        style={styleFive}
        d="M228 104c-1-16-5-32-3-48 0-3-2-7 2-9-4-6-1-12-1-18-1-5-4-10-7-14 6-3 9-1 8 6a7 7 0 002 6c5 4 7 9 7 15-4 0-6 3-4 7l4 10v1l-3 1a15 15 0 00-2-3c-1-1-1-3-3-3-2 1-1 3-1 4-2 7-1 14 0 22 0 7 3 15 1 23z"
      />
      <path
        style={styleTwo}
        d="M230 116a5 5 0 01-1-3 5 5 0 00-1-3v-6c1-6 0-12-1-17l-1-6c0-7-1-15 1-22a6 6 0 000-1l1-3 2 2a4 4 0 001 1 9 9 0 012 2 3 3 0 010 3v2h1l1 1h-1c-1 1-2 3-1 4a16 16 0 011 6c0 3-1 6 1 8l1 8a34 34 0 000 3v4a60 60 0 000 8c1 5-1 8-6 9z"
      />
      <path
        style={styleTwo}
        d="M228 104c2-8-1-16-1-23-1-8-2-15 0-22 0-1-1-3 1-4 2 0 2 2 3 3a15 15 0 012 3c1 1-3 4 1 5-1 1-2 2-1 4 1 5-1 10 2 15 2 2 0 7 1 10v12c0 5-1 8-6 9-2-2-1-5-2-6v-3-3z"
      />
      <path
        style={styleFour}
        d="M95 162a1 1 0 01-1 0 2 2 0 010-2c3-2 5-6 6-9a25 25 0 014-7 16 16 0 002-6l4-7a2 2 0 001-1l-2-2v-2a12 12 0 012 0 2 2 0 001 0 3 3 0 001-2c0-3 1-4 3-5a15 15 0 002-3c5-5 4-11 4-16v-3l-2-18v-3a56 56 0 00-3-16 23 23 0 01-2-8 27 27 0 000-6c3 4 4 9 4 14l1 2 1 7a74 74 0 011 10l1 5a52 52 0 010 8v1c0 2-1 4 2 5 2 10 2 21 1 31v11h-1v-18-10c-4 2-5 6-6 9a36 36 0 01-2 4l-4 7-11 21a16 16 0 00-1 3c-1 3-2 5-5 6a5 5 0 01-1 0z"
      />
      <path
        style={styleFour}
        d="M94 160c6-3 6-11 10-16 3-4 2-9 6-13 2-1 1-3-1-4v-1c2 0 4 1 4-2 0-4 4-5 6-7 5-7 3-13 3-20l-2-21a56 56 0 00-3-16c-2-5-1-10-2-14 3 5 4 10 4 16 1 6 3 11 3 17l1 13c0 3-1 5 2 6 3 14 1 28 1 42-2-9-1-19-1-28-5 3-6 9-8 13l-16 28c-1 4 0 8-5 9-2 0-2 0-2-2z"
      />
      <path
        style={styleTwo}
        d="M615 104c-2-4-1-7 0-10l1-1v-2c1-2 4-2 6-3a17 17 0 003 0l9-4 3-2a4 4 0 011 0l2-1h1a7 7 0 003-2 4 4 0 012-1l4 2 1 1a3 3 0 011 2l-2 2-1 1a120 120 0 01-34 18z"
      />
      <path
        style={styleTwo}
        d="M616 91c2-3 6-2 9-3l12-5c1-1 3 0 3-2l4-1c3-4 5-1 6 1 3 3 0 4-2 5a119 119 0 01-33 18c-2-4 0-8 1-11z"
      />
      <path
        style={styleFour}
        d="M599 180v-3a16 16 0 00-1-6 4 4 0 011-4c2-2 2-3 1-5v-5c-2-3-2-6-2-10a24 24 0 00-1-6v-1h1a4 4 0 011 3l2 3c2 0 3 2 3 4l1 1a20 20 0 012-2 11 11 0 003-5h1l1 1-1 5a16 16 0 010 3h-1l1 1v7h-1l-1 1a25 25 0 000 6c0 4-1 9-8 11l-2 1z"
      />
      <path
        style={styleFour}
        d="M600 157c-3-5-1-11-2-16 2 1 0 4 3 5 3 0 3 3 3 6 2-3 5-4 6-8 1-1 2 0 2 1-2 2-1 5-1 8v1l-1 7-1 1c-1 6 2 14-8 17l-2 1-1-9a4 4 0 011-4c3-2 2-3 1-5v-5z"
      />
      <path
        style={styleFive}
        d="M455 151l-2-13a54 54 0 01-1-8l1-1a1 1 0 00-1-1l-1-1h1c0-8-2-17-4-25l-1-5c0-2-1-3-2-3a9 9 0 00-2 1h-1l-1-19h1a2 2 0 001 0 3 3 0 001-2 6 6 0 010-2 5 5 0 000-3 4 4 0 010-3 3 3 0 012-1h1v2c0 2 0 4 2 6a25 25 0 011 4 15 15 0 001 5v1c-2 1-2 2-2 4v1a91 91 0 002 16 121 121 0 012 13 471 471 0 014 26 15 15 0 001 2l1 4-4 2z"
      />
      <path
        style={styleFive}
        d="M441 76c4 1 3-2 3-4 1-2-2-6 2-6 1 2 0 5 3 7 1 3 0 7 2 10-3 1-2 3-2 5 0 10 3 19 4 29 1 9 1 18 4 26 1 3 4 6-2 8 1-7-2-14-3-21v-2c0-11-2-21-4-31-1-4-3-3-5-2l-2-19zM136 149a6 6 0 01-2 0v-1l-1-1v-10c2-2 3-3 3-5l-3-5 2-4c0-2 0-4 2-5 2 0 2-1 3-2a23 23 0 013-5l1-2 3 4h-1l-1 2 3 1 1 2v1l3 6c1 2 3 4 2 7a7 7 0 01-4-5l-2-2a2 2 0 00-1 0v3a14 14 0 010 2v0a10 10 0 00-1-1 6 6 0 01-1-2l-2-2c-2 1-2 3-2 6a23 23 0 010 6v8a2 2 0 010 2 6 6 0 01-5 2zm7-30a1 1 0 000 1l2 2v-1l-2-2z"
      />
      <path
        style={styleFive}
        d="M133 127c3-2 0-7 4-8l3-3 4-6 2 3c-2 3 0 3 2 3l1 2v1c0 5 6 7 5 13a6 6 0 01-4-5c0-2-1-3-3-2v3a24 24 0 010 3 19 19 0 00-1-2c-1-1-1-4-3-4-3 1-2 4-2 6 1 5-2 9 0 14 1 2-4 5-7 4l-1-2v-8-2c4-3 4-7 0-10zm13-6l-3-2v1l2 2 1-1z"
      />
      <path
        style={styleFour}
        d="M616 131c-2 0-3 0-3-2-1-2-2-2-3-2a9 9 0 01-1-1 7 7 0 00-2 0c-2 0-5 0-5-4a46 46 0 000-5c-1-5-2-10 2-15v1c0 3 1 4 2 4a12 12 0 004-1 2 2 0 011 0v5h3l6 3 7 4h2a8 8 0 01-3 1 17 17 0 01-6-1 26 26 0 00-3-1 7 7 0 01-1-1 4 4 0 00-2 0 2 2 0 00-1 1v3a9 9 0 010 1c1 4 4 4 8 4h3l-1 1c0 2-2 2-3 3a10 10 0 00-3 2z"
      />
      <path
        style={styleFour}
        d="M617 131c-2 0-4 0-4-2l-4-3c-2-1-6 1-7-4 0-6-3-13 2-19 0 5 1 5 6 3a2 2 0 011 0v2c-2 4 1 4 3 3l13 7h2c-5 2-8-1-12-1-1-1-3-2-4-1s0 3 0 5c1 5 6 5 10 5-1 3-4 3-6 5z"
      />
      <path
        style={styleFive}
        d="M62 183c-4-1-4-4-4-7 0-14-1-29-3-42v-4c-1-5-2-10 1-16 4 3 3 6 3 9a13 13 0 000 5c2 7 2 15 3 22a150 150 0 002 17 20 20 0 010 6 37 37 0 00-1 4l-1 6z"
      />
      <path
        style={styleFive}
        d="M62 183c-4-2-4-4-4-7l-2-42c-1-6-3-13 0-19 6 3 2 9 3 13 3 13 2 26 5 39l-1 10-1 6z"
      />
      <path
        style={styleThree}
        d="M641 130l-6-1a32 32 0 00-4-1c-3 0-5 0-8-2h-2c-4 0-7-1-8-5a8 8 0 00-1-1c0-1-1-3 1-4a2 2 0 011 0 5 5 0 012 0 7 7 0 001 0 27 27 0 013 1 17 17 0 006 2 8 8 0 002-1h1l4 1 11 3c1 1 3 2 3 4l-3 5-3-1z"
      />
      <path
        style={styleThree}
        d="M623 126c-4 0-9 0-10-5 0-2-2-3 0-5s2 0 4 1c4 0 7 3 12 1l14 4c5 3 5 5 1 9l-9-2-12-3zM24 149a6 6 0 01-1 0c-2 0-3-2-3-5v-1c0-4 0-7-2-9v-1-3l-1-8v-4c0-5-1-10 1-15v1a27 27 0 002 5 34 34 0 011 4l1 5c1 5 2 10 6 14v14c-1 1-2 3-4 3z"
      />
      <path
        style={styleThree}
        d="M28 133v13c-1 2-2 3-5 3-2-1-3-2-3-5s1-7-2-11l-1-11c0-6-1-12 1-18l3 9c1 7 1 14 7 19v1z"
      />
      <path
        style={styleTwo}
        d="M250 58l-1-1a14 14 0 00-1-1l-5-4 3-6a13 13 0 011-2c2-1 3-2 3-4v-1c2-1 4-2 4-4v-1h1a5 5 0 001-2l4-2c1 0 2 0 3 2a4 4 0 01-1 3v1a3 3 0 01-1 0v2h1l1 1-1 2c-4 2-6 7-7 11a55 55 0 01-3 6h-2z"
      />
      <path
        style={styleTwo}
        d="M254 35l3-3c2-3 4-3 6 0 1 2-1 3-1 4-1 0-3 2 0 3v1c-6 5-7 12-11 18h-1a26 26 0 00-2-2c-6-4-6-5-2-10 1-2 4-3 4-6v-1c2-1 4-2 4-4z"
      />
      <path
        style={styleFive}
        d="M611 61a6 6 0 000-1v-1l1-1 23-13 11-9c2-2 4-3 8-3v3l-7 5-6 5a22 22 0 00-5 3c-3 2-5 4-9 4h-1l-2 3c-1 5-5 7-9 8l-1 1-1 1h-2z"
      />
      <path
        style={styleFive}
        d="M654 36c-6 1-8 8-13 10s-8 8-15 7l-2 3c-1 5-6 7-10 9h-1l-2 1v-5a6 6 0 000-1l1-1a126 126 0 0123-14l11-8c2-3 5-4 8-4v3zM9 168l-1-2v-1a19 19 0 01-1-3c0-2 0-5-2-6v-1c4 0 4 3 4 5a8 8 0 000 2 8 8 0 011 1v1l1-1a5 5 0 011-1l1-7a27 27 0 010-3l1-35V98a7 7 0 012 0 2 2 0 011 1 4 4 0 011 2 6 6 0 000 2v1l-1 14 1 4v11l-2 27c1 4-3 6-5 7h-1a2 2 0 01-1 1z"
      />
      <path
        style={styleFive}
        d="M18 104c-2 6-1 12-1 18l1 11c-1 9-3 18-2 27 1 4-3 6-6 7-2 1-2-1-2-2-1-3 0-7-3-9 5 0 3 3 4 6l1 2 2-2c2-3 1-7 2-10V99c5-2 3 3 4 5zM387 134v-2a7 7 0 01-1-3v-1l3-1a6 6 0 01-2-3c0-2 0-4-3-4v-1l-1-22V87a28 28 0 00-1-3l1-7-1-2v-2l2-1v1a143 143 0 011 15l1 20a12 12 0 003 5 14 14 0 012 5 16 16 0 002 2l2 7c0 3 0 6-3 8z"
      />
      <path
        style={styleFive}
        d="M384 73c1 12 0 24 2 35l5 10c1 3 4 5 4 9 0 3 0 6-3 8l-5-2-1-4c1-1 4-1 3-2-2-2 0-7-5-8l-1-32c0-3-2-7 0-10l-1-2v-2h2z"
      />
      <path
        style={styleThree}
        d="M449 73c-2-1-2-4-3-6v-2l3-3c5-6 9-12 15-16a37 37 0 004-3c2-2 5-5 9-5h1v1l-6 6-12 14a40 40 0 00-4 5c-2 4-3 7-7 9z"
      />
      <path
        style={styleThree}
        d="M449 73c-3-2-2-5-3-7 6-7 11-15 18-20 5-3 8-7 13-7l-17 20c-4 5-6 11-11 14z"
      />
      <path
        style={styleTwo}
        d="M653 146l-8-3-4-1c-2-2-5-3-8-3v-1l-2-2a4 4 0 01-3-2 2 2 0 012-3 10 10 0 012 0l9 1h3a1 1 0 011 1l2 1c3 2 5 4 8 4a9 9 0 004-1h1l1 3h-1c-2 4-4 6-7 6z"
      />
      <path
        style={styleTwo}
        d="M644 133a1 1 0 011 0c4 3 8 7 14 5h1v2c-4 7-7 7-15 3-4-2-8-5-12-5 0-1 0-2-2-3-1 0-3-1-3-3l4-1 12 2z"
      />
      <path
        style={styleFive}
        d="M265 104l-2-1v-1c3-6 0-11-3-15l-1-1-6-9-2-3a3 3 0 011-1l2 1 1 1 1 1 10 8 2 2 3-2c3 3 6 5 2 10l-2 4a36 36 0 01-5 7h-1z"
      />
      <path
        style={styleFive}
        d="M271 85c3 2 5 4 2 9-2 3-4 8-8 11 0-1 0-2-2-3 4-6 0-11-4-16-2-5-5-8-8-12 2-2 3 0 4 1 3 3 6 7 11 9 1 4 3 2 5 1zM565 126c-2-6-1-12 0-18v-9l1-22 1-15c0-2 0-3 2-3h1l-1 10v35l-1 19c0 3-1 3-3 3v1z"
      />
      <path
        style={styleFive}
        d="M565 126c-2-9 0-18 1-27l1-37c0-2 1-3 3-3l-2 17 1 18-1 29c0 3-1 3-3 3z"
      />
      <path
        style={styleFour}
        d="M87 150l-7-26a1481 1481 0 01-9-34c-2-8-1-15 5-23v1l-2 6a17 17 0 00-2 6 4 4 0 001 3c1 1 2 2 0 4l2 7 2 8h1a4 4 0 011 0c2 1 2 2 2 3l-2 2 1 5c1 5 2 11 5 16a9 9 0 010 3v2 3h1a14 14 0 012 15l-1 1z"
      />
      <path
        style={styleFour}
        d="M73 87c-1 5 5 9 4 15-1 1 1 0 2 1 3 1 3 2 0 3v1l5 21 1 5c-2 1 0 2 1 3a14 14 0 011 15l-6-27c-2-12-6-23-10-35-2-8 0-15 5-21 0 4-4 8-4 12 0 3 4 4 1 6z"
      />
      <path
        style={styleTwo}
        d="M247 138l-5-3 1-5 14-18 5-8 1-1v-1c2 0 2 1 3 2v1l-1 2-1 1-3 7-1 2-1 2-1 3a6 6 0 00-2 3l-1 1a34 34 0 01-8 12z"
      />
      <path
        style={styleTwo}
        d="M263 102c2 1 2 2 2 3v2l-1 1-3 7-1 1-1 3-1 3-3 4a33 33 0 01-8 12c-5-2-6-3-3-7l18-27 1-1v-1z"
      />
      <path
        style={styleFour}
        d="M382 73a10 10 0 00-1-5c0-2-1-5 1-8a2 2 0 000-1 4 4 0 00-1-3l-2-1v-1c2 0 3-1 3-2l-2-2a14 14 0 01-1-2 2 2 0 010-2c4-5 3-11 2-16a55 55 0 01-1-6 20 20 0 010-6v-8l-1-3a19 19 0 00-1-4l1-2a3 3 0 002 0V0v1a177 177 0 012 22l1 10v10l1 17a4 4 0 010 3h-1l1 2v6l-1 2h-2z"
      />
      <path
        style={styleFour}
        d="M384 73h-2c1-4-3-8 0-13 1 0 1-3-1-4-1-1-2-1-1-2 5-2 1-4-1-6a2 2 0 010-2c6-7 2-14 1-22-1-5 2-9 0-14l-2-7c0-2 2-1 3-2l3 32c0 9-1 18 1 27l-1 3 1 2v6l-1 2zM505 114c-6-1-7-5-9-9l-1-3a50 50 0 01-2-5l-1-3-3-1v-2h2v-1c-1-2 1-4 2-5a5 5 0 002-3l2-1a8 8 0 012 0 2 2 0 011 1 3 3 0 010 2l-2 4-2 5 6 2v1l2 9 1 9z"
      />
      <path
        style={styleFour}
        d="M505 114c-7-1-8-7-10-12l-3-8c-1-2-2-1-3-1v-1l3-2c-2-4 3-4 4-8h3v2l-1 4c-3 6-3 7 4 7v2l3 17z"
      />
      <path
        style={styleOne}
        d="M668 153a25 25 0 00-4-5l-4-8v-3c1-3 3-4 6-4a9 9 0 015 2h1l2 3a1 1 0 000 1 2 2 0 010 1 2 2 0 011 0v1c2 6-3 9-7 12zm3-9a1 1 0 00-1 0l1 1 1-1-1-1z"
      />
      <path
        style={styleOne}
        d="M660 140v-2c2-6 6-7 11-3l1 1 1 2v3-1l2 1c2 6-2 9-7 12-2-5-7-8-8-13zm12 4l-1-1-1 1 1 1z"
      />
      <path
        style={styleTwo}
        d="M159 159l-2-1-5-16-2-6c-1-2-1-4-3-5v-1a13 13 0 00-1-2v-1c0-1-1-2 1-2a3 3 0 011-1c1 0 2 1 2 3a6 6 0 004 4l2 6 6 15a4 4 0 010 3 4 4 0 000 2l-3 2z"
      />
      <path
        style={styleTwo}
        d="M147 131a24 24 0 000-3c-1-1-2-3 0-3 1-1 2 0 3 2a6 6 0 004 5l8 20v5c-1 2-3 3-5 1l-7-22c0-2-1-4-3-5zM672 162a4 4 0 01-1-1c-2 0-2-2-2-4a12 12 0 000-1v-1h1a13 13 0 002 1 3 3 0 002-2l2-4a30 30 0 002-5v-4a2 2 0 00-2 0 10 10 0 00-1 0 4 4 0 01-1 0 2 2 0 000-1 1 1 0 00-1 1v-1-1a2 2 0 010-1 2 2 0 001 0 4 4 0 002-1 4 4 0 013-2 3 3 0 011 1l5 5a29 29 0 002 4 2 2 0 010 1 2 2 0 01-1 1l-7 8-2 3a6 6 0 01-5 4z"
      />
      <path
        style={styleTwo}
        d="M673 140v-2c3 0 4-4 7-2s4 6 6 9a1 1 0 010 2c-4 3-6 7-9 11-1 2-3 4-6 3-2-1-1-3-2-5 2 0 5 0 6-2l3-9c1-4 0-5-3-4l-2-1z"
      />
      <path
        style={styleFive}
        d="M22 71c-4-1-5-3-5-7 0-2-1-3-3-5l-2-5a25 25 0 00-2-7l-1-3c-1-2-3-4-5-4a3 3 0 00-1 0c-2 1-1 3-1 5v1l1 2c0 3 1 7-1 10-1-7-3-13-1-20 0-1 0-2 2-2h1a4 4 0 013 1l1 1a8 8 0 012 3c1 6 4 12 8 18l4 7a7 7 0 010 3v2z"
      />
      <path
        style={styleFive}
        d="M22 70c-3-1-5-2-5-6s-5-6-5-10L9 44c-1-2-3-5-6-4-2 0-1 4-1 6 0 4 2 8 0 12-1-7-3-13-1-19 1-2 0-3 2-3l4 1 2 4c3 9 8 17 13 26v3zM56 107l-3-1a2 2 0 010-1c1-5-1-8-3-11v-2l1-4c0-3 0-6-2-9l1-5a2 2 0 011 0 4 4 0 011 0c2 0 4 3 5 5v1a10 10 0 010 3 48 48 0 00-1 12 49 49 0 010 12z"
      />
      <path
        style={styleFive}
        d="M56 107c-2 0-3-1-3-2 1-4-1-8-2-11l-1-2c1-5 2-9-1-13 0-2 0-5 3-5 2 0 4 3 5 5a12 12 0 010 4c-2 8 0 16-1 24zM392 170a11 11 0 00-3-2 13 13 0 01-3-1l-4-2-3 3a9 9 0 01-2-5 15 15 0 000-2v-1a2 2 0 011 0 5 5 0 012 0 5 5 0 001 0 1 1 0 001-1l1-1v-1c2 0 3 0 4-2 1-1 2-4 5-5v20z"
      />
      <path
        style={styleFive}
        d="M382 160l1-2c2 0 3-1 4-3l5-5v20l-5-3c-3-2-6-4-8 1-2-3-1-5-2-7 1-2 4 0 5-1z"
      />
      <path
        style={styleFour}
        d="M551 98c-2-4-2-8-2-11v-1-8-10-12c0-7 0-14 2-21a4 4 0 00-1-2c0-1 0-2 2-3a1099 1099 0 00-1 38c0 9-1 19 1 28a1 1 0 010 1 4 4 0 00-1 1z"
      />
      <path
        style={styleFour}
        d="M552 30l-1 29c0 12-1 25 1 37l-1 2c-2-4-2-8-2-12V68c1-11-1-22 2-33 0-1-2-4 1-5z"
      />
      <path
        style={styleFive}
        d="M633 139a28 28 0 00-8-1h-2v-2l-2-3a4 4 0 00-3 1l-2-1v-1a2 2 0 001-1v-1a10 10 0 012-1l4-4 8 3a32 32 0 014 0l6 2 3 1v2l-3-1h-9a10 10 0 00-2-1l-1 1a2 2 0 000 2 4 4 0 002 1c2 1 2 2 2 3v1z"
      />
      <path
        style={styleFive}
        d="M644 133l-12-2-4 1c0 2 2 3 3 3 2 1 2 2 2 3a28 28 0 00-10 0v-2c-1-4-2-4-5-2-3 0-1-2-1-3 2-2 5-2 6-5l12 3 9 2v2z"
      />
      <path
        style={styleFour}
        d="M383 158c-1-5-1-10 4-14a4 4 0 002-2 5 5 0 00-2-4 4 4 0 01-1-3 3 3 0 011-2l5 1a39 39 0 010 17c-2 0-3 2-5 5l-4 2z"
      />
      <path
        style={styleFour}
        d="M392 150l-5 5c-1 2-2 3-4 3 0-5 0-10 4-14 3-1 2-4 0-6-1-2-2-3 0-5l5 2a39 39 0 010 15z"
      />
      <path
        style={styleTwo}
        d="M607 186a17 17 0 01-2 0 16 16 0 00-1 0 4 4 0 00-1 0 4 4 0 01-1 0 2 2 0 01-2-1 3 3 0 010-3 10 10 0 001-2v-1-1c7-1 7-6 7-10a25 25 0 011-6l1-2h1c2 2 1 5 1 7a9 9 0 00-1 3 93 93 0 010 11l-1 2c0 3-1 3-3 3z"
      />
      <path
        style={styleTwo}
        d="M601 179c10-3 7-11 8-17l1-1c4 2 1 6 1 9a114 114 0 01-1 13c0 4-5 2-7 2-3 1-3 0-2-3a18 18 0 000-3z"
      />
      <path
        style={styleFour}
        d="M69 129c-2-2-2-6-2-7 2-4 1-7 1-11v-3l-1-20-1-18a25 25 0 00-1-3v-7l1-1v1c3 26 4 48 4 69z"
      />
      <path
        style={styleFour}
        d="M69 129c-2-2-2-6-1-7v-14l-2-38c0-4-2-7 0-10a606 606 0 013 69z"
      />
      <path
        style={styleFive}
        d="M613 112l-3-1 1-3v-2a2 2 0 00-1 0 12 12 0 01-4 2c-2 0-2-2-2-5v-1a21 21 0 014-2c2-2 5-4 5-8l2-1h1v3c-1 3-2 6-1 10a10 10 0 01-1 2v6h-1z"
      />
      <path
        style={styleFive}
        d="M614 112c-2 0-5 0-3-4v-2a2 2 0 00-1 0c-5 2-6 2-6-3 3-4 9-5 10-11l2-1v2c-1 3-3 7-1 11 0 2-3 5-1 8z"
      />
      <path
        style={styleFour}
        d="M337 60a7 7 0 01-2-4 8 8 0 00-1-3l-1-12V31a2 2 0 010-1 4 4 0 013-2 5 5 0 013 1v1l-2 4a43 43 0 011 11c0 4-1 9 1 13l-1 2z"
      />
      <path
        style={styleFour}
        d="M338 60c-3-2-2-5-4-7-2-8 1-15-1-22 0-2 3-4 6-2l-2 5c2 8-1 16 2 24l-1 2z"
      />
      <path
        style={styleFive}
        d="M28 133v-1a38 38 0 00-1-7c-1-5-1-10 2-15 2 0 3 1 4 3a6 6 0 002 2l-2 6c-1 4-2 8-5 12z"
      />
      <path
        style={styleFive}
        d="M29 110c3 0 4 4 6 5-2 6-3 12-7 18v-1c0-7-4-15 1-22zM446 168l-1-6-4-18a2 2 0 010-2v-2l2-1h1l1 3-1 1h-1v1a1 1 0 011-1c4 7 5 15 3 25z"
      />
      <path
        style={styleFive}
        d="M444 144c5 7 4 16 2 24l-5-24c-1-2 2-2 1-4l1-1 1 1v3a9 9 0 00-1 0l1 1z"
      />
      <path
        style={styleTwo}
        d="M387 176a5 5 0 01-1 0 9 9 0 00-2 0c-2 0-4 0-4-3a8 8 0 00-1-2 6 6 0 010-3l3-4 5 2a13 13 0 002 2 11 11 0 013 2l-1 2-2 1a3 3 0 010 3 2 2 0 01-2 0z"
      />
      <path
        style={styleTwo}
        d="M379 168c2-5 5-3 8-1l5 3c0 2-3 1-3 3 1 4-2 3-3 3-2-1-6 0-6-3l-1-5z"
      />
      <path
        style={styleFour}
        d="M230 151c-9-6-13-14-14-26a71 71 0 016 10 63 63 0 007 10 6 6 0 011 6z"
      />
      <path
        style={styleFour}
        d="M230 151c-9-6-13-15-14-26l13 20a6 6 0 011 6zM266 84l-10-7-1-2h-1l-2-2a2 2 0 00-1 1l-4-6 3-4 4 4c2 5 6 11 12 13v3z"
      />
      <path
        style={styleFour}
        d="M266 84c-5-2-8-6-11-9-1-1-2-3-4-1l-4-6c2-6 4-5 7 1 2 5 6 10 12 12v2zM252 146c-2 0-3-1-4-4a14 14 0 00-1-3v-2a33 33 0 008-11v-1a6 6 0 013-4v1c0 3-1 5-3 8l-1 4-1 1c-1 3-2 7 2 9v1a6 6 0 01-3 1z"
      />
      <path
        style={styleFour}
        d="M247 138a33 33 0 008-12l3-4c0 4-3 8-4 12-2 4-4 8 1 11-4 3-6 0-7-3a32 32 0 00-1-4zM499 131c-5-5-8-12-11-18l-4-8v-1a7 7 0 011 0c4 0 6 4 7 7 0 4 2 8 4 11l2 5a11 11 0 011 2v2z"
      />
      <path
        style={styleFour}
        d="M484 105c5-1 7 3 7 6 1 6 5 10 7 16a20 20 0 011 4c-7-8-10-18-15-26zM440 133c-4-2-3-6-3-9 1-4 0-7-1-11a49 49 0 010-6 16 16 0 010-2 14 14 0 000-3c3 3 3 6 3 9a23 23 0 001 6 34 34 0 010 16z"
      />
      <path
        style={styleFour}
        d="M436 102c4 5 2 10 3 15a34 34 0 011 16c-3-2-3-6-3-9 1-6-1-12-1-17v-5zM552 127c1-2 0-3-1-5a7 7 0 01-1-4l1-13v-6c2 4 2 7 2 11a39 39 0 001 6 14 14 0 010 3l1 5a2 2 0 010 2 3 3 0 01-3 1z"
      />
      <path
        style={styleFour}
        d="M551 100c3 5 1 11 2 16l1 8c2 1 0 3-2 3 1-4-2-6-2-9l1-18z"
      />
      <path
        style={styleFive}
        d="M2 113V95v-8l1-8v-4c2 6 1 12 1 18l-1 8a24 24 0 000 4c1 3 1 6-1 9z"
      />
      <path
        style={styleFive}
        d="M3 75c2 9 0 17 0 26 0 4 2 9-1 12-2-8 0-17 1-26V75zM583 139a1 1 0 010-1 3 3 0 00-1 0 3 3 0 01-1 1 4 4 0 01-3-2 2 2 0 00-1 0 6 6 0 00-2 0 6 6 0 01-2 1 2 2 0 01-2-1 2 2 0 000-2l-2-1-1-1h-1 1a10 10 0 017-3 12 12 0 014 1v1a4 4 0 001 2l3 1a6 6 0 012 1 3 3 0 00-1 3 1 1 0 01-1 0zm-10-6a1 1 0 001 1l1-1h-1a2 2 0 00-1 0z"
      />
      <path
        style={styleFive}
        d="M582 138c-1 1-2 1-4-1s-5 2-7 0c1-4-3-2-3-4a10 10 0 0111-2c-1 6 4 4 6 5a3 3 0 00-1 3l-2-1zm-7-5a6 6 0 00-2 0s-1 0 0 0a2 2 0 001 1l1-1z"
      />
      <path
        style={styleFour}
        d="M672 156a14 14 0 01-2 0h-1a4 4 0 00-1-1v-3c5-3 8-6 7-11v-1a10 10 0 011 0 3 3 0 013 1v4a31 31 0 01-3 6l-1 3a3 3 0 01-3 2z"
      />
      <path
        style={styleFour}
        d="M675 141c3-1 4 0 3 4l-3 9c-1 2-4 2-6 2 0-1-2-2-1-3 5-3 9-6 7-12z"
      />
      <path
        style={styleFive}
        d="M562 29a2 2 0 01-2-1 4 4 0 010-3 17 17 0 00-1-6v-2l2-2 1-2h1c3 3 4 6 3 12a2 2 0 01-1-1l-1-1a2 2 0 00-1 0l-2 3 2 1v1a5 5 0 00-1 1z"
      />
      <path
        style={styleFive}
        d="M562 29c-3-1-2-3-2-4a17 17 0 00-1-6v-2c3 0 1-4 3-4 4 3 5 7 4 12-1-1-1-4-3-2s-3 3-1 5a5 5 0 000 1zM655 138c-3 0-6-2-8-4l-2-1a13 13 0 003 0h3c3 0 6 0 8 5a10 10 0 01-4 0z"
      />
      <path
        style={styleFive}
        d="M659 138c-6 2-10-2-14-5 5 1 11-2 14 5zM321 128v-6a18 18 0 001-3c0-2 2-4 3-4a4 4 0 013 1v1a30 30 0 00-2 4c-1 2-2 5-5 7z"
      />
      <path
        style={styleFive}
        d="M321 128c-1-3 1-6 1-9 1-2 3-5 6-2-2 3-3 8-7 11z"
      />
      <path
        style={styleFour}
        d="M553 144a31 31 0 000-8 29 29 0 01-1-8v-1h2a2 2 0 011 1 2 2 0 010 2v3a6 6 0 002-1h1a2 2 0 010 2l-3 7-1 3z"
      />
      <path
        style={styleFour}
        d="M553 128c1 0 3-1 2 2 0 0-3 5 2 2l1 2-5 10v-16z"
      />
      <path style={styleFive} d="M4 145l-2-28h1v3c1 9 3 19 2 29H4v-4z" />
      <path style={styleFive} d="M2 117c2 10 4 21 3 32l-3-32z" />
      <path
        style={styleTwo}
        d="M50 92l-1-2a4 4 0 00-1 0 4 4 0 01-2 1v-1a11 11 0 001-4c0-3 0-6 2-7v-1 1c3 3 2 6 2 9v4z"
      />
      <path
        style={styleTwo}
        d="M49 79c3 4 2 8 1 13 0-4-2-2-4-2 2-3-1-8 3-11z"
      />
      <path
        style={styleFour}
        d="M558 155c-3 0-5-2-7-5l-1-4a4 4 0 013-2 6 6 0 001 5 7 7 0 005 3 7 7 0 001 0 3 3 0 013 1v1a17 17 0 01-5 1z"
      />
      <path
        style={styleFour}
        d="M553 144c-1 4 1 8 6 9h4c-5 2-9 3-12-3-1-2-2-5 2-6zM76 67c1-7 5-12 9-17l-5 12-4 6z"
      />
      <path
        style={styleFour}
        d="M85 50c-2 6-6 12-9 17 1-7 5-12 9-17zM237 165a15 15 0 01-7-13v-1c3 1 3 3 3 5a6 6 0 001 3 13 13 0 013 4v1l1 1z"
      />
      <path
        style={styleFour}
        d="M237 164a15 15 0 01-7-12c4 0 2 5 4 7 2 1 2 4 3 5zM176 119a5 5 0 00-2-1l-3-2h-1l1-1c3-1 6-3 6-7v-1l1 5a11 11 0 000 1 8 8 0 01-1 4v2z"
      />
      <path
        style={styleFour}
        d="M171 116c3-2 6-4 6-8 2 1 1 3 1 5l-2 5c-1-1-4 0-5-2zM177 107c-2-3-2-3 1-7 0-2 1-3 2-3a3 3 0 012 1 14 14 0 00-2 4c0 2-1 4-3 5z"
      />
      <path
        style={styleFour}
        d="M177 107c-2-3-2-3 1-7 1-2 2-4 4-2-2 3-2 7-5 9zM31 78c1-5 3-11 8-16-1 5-4 11-8 17z"
      />
      <path
        style={styleFour}
        d="M39 62c-2 6-4 12-8 17 2-6 4-12 8-17zM95 35h-2l1-1 1-1a28 28 0 002-3c1-2 2-2 3-2l3 2v1a3 3 0 01-1 0h-1l-2 1c0 2-2 3-4 3z"
      />
      <path
        style={styleFour}
        d="M103 31c-2 0-3-1-4 1 0 3-3 2-5 2a53 53 0 003-4c2-4 4-2 6 1z"
      />
      <path
        style={styleTwo}
        d="M585 136a6 6 0 00-3 0l-3-1a4 4 0 010-4 6 6 0 011 0l6 2v1l1 2v1z"
      />
      <path style={styleTwo} d="M585 136c-2-1-7 1-6-5 3 0 5 1 7 3l1 2h-2z" />
      <path style={styleFour} d="M65 52c-3-6-2-12 0-20v20z" />
      <path
        style={styleFour}
        d="M65 52c-3-7-2-14 0-20zM49 41a13 13 0 01-5 14h-1z"
      />
      <path
        style={styleFour}
        d="M49 41a13 13 0 01-5 13l5-13zM58 25a23 23 0 014-7l2-2 3 3a6 6 0 00-2 0c-2 0-3 1-4 3a8 8 0 01-3 4z"
      />
      <path
        style={styleFour}
        d="M67 19c-6-2-6 5-9 6a22 22 0 014-7c2-3 3-3 5 1zM514 44v-3c0-2 0-5 3-6a8 8 0 000 4c1 2 1 4-3 6z"
      />
      <path
        style={styleFour}
        d="M517 35c-1 3 3 8-3 10 2-3-2-8 3-10zM133 147c0-4-3-5-5-6a18 18 0 01-2-1h-1 1a5 5 0 013-1 16 16 0 012 0 16 16 0 002 0v8z"
      />
      <path style={styleFour} d="M133 139v8c0-5-4-5-7-7 2-2 5-1 7-1z" />
      <path
        style={styleFive}
        d="M27 86a7 7 0 00-1-2 4 4 0 01-1-2v-1a1 1 0 001-1v-1a4 4 0 011 1l2 1 1-1h1v4a6 6 0 00-1 1v1z"
      />
      <path
        style={styleFive}
        d="M31 80c1 2-1 4-1 5h-3l-2-3a1 1 0 001-2v-1c2 1 2 4 5 1z"
      />
      <path
        style={styleFour}
        d="M65 32c-1-3 0-6 1-9a34 34 0 001-4v-1a3 3 0 012 2 13 13 0 00-2 6 13 13 0 01-2 6z"
      />
      <path
        style={styleFour}
        d="M65 32c-1-5 1-9 2-13l2 1c-3 4-2 8-4 12zM522 38a5 5 0 01-3-1 5 5 0 00-2-1l-1-1h1l3-2c2 0 3 1 4 3v1a3 3 0 01-2 1z"
      />
      <path
        style={styleFour}
        d="M524 36c-3 4-5-1-7-1 3-3 5-2 7 1zM556 20a9 9 0 01-4-1 2 2 0 010-2v-2a2 2 0 011 0 5 5 0 012 1 4 4 0 001 0 2 2 0 002-1l1 2v2a9 9 0 01-3 1z"
      />
      <path
        style={styleFour}
        d="M559 17v2a9 9 0 01-7 0v-4 1c2-1 4 2 6-1l1 2z"
      />
      <path style={styleFive} d="M569 51c-1-3-3-6 1-10v7a26 26 0 000 2v1z" />
      <path style={styleFive} d="M570 50c-2-3-4-6 0-8v8z" />
      <path style={styleTwo} d="M562 28l-1-2 1-3a3 3 0 012-1l1 1 1 1v3l-4 1z" />
      <path style={styleTwo} d="M563 28c-3-2-2-3 0-5s2 1 3 2v1l-3 2z" />
      <path
        style={styleFour}
        d="M93 160a9 9 0 01-3-4c0-2-1-4-3-5a4 4 0 012-1c2 0 2 2 2 4a11 11 0 001 2 7 7 0 011 4z"
      />
      <path style={styleFour} d="M88 151c2-1 3 1 3 3l2 6c-3-3-2-7-5-9z" />
      <path style={styleFive} d="M3 67l-1-5v-3h1c2 3 1 6 0 8v1z" />
      <path style={styleFive} d="M3 60c2 2 1 5 0 7v-7z" />
      <path
        style={styleTwo}
        d="M558 16v-3a1 1 0 012-1 8 8 0 012 1h1-1l-1 2c0 1 0 3-2 3z"
      />
      <path style={styleTwo} d="M559 17l-1-2c0-4 2-3 4-2-2 1 0 4-3 4z" />
      <path style={styleFour} d="M39 61v-1c1-2 2-4 5-6v1c-1 2-2 5-5 7z" />
      <path
        style={styleFour}
        d="M44 54c-1 3-2 6-5 8 1-3 2-6 5-8zM216 126c-4-1-4-3-5-6v-2l3 4a10 10 0 002 3l1 1z"
      />
      <path
        style={styleFour}
        d="M216 125c-4 0-4-4-5-7 3 2 3 5 5 7zM511 48a2 2 0 012-2 3 3 0 011 2 4 4 0 01-1 3 2 2 0 01-1 1h-1z"
      />
      <path style={styleFour} d="M513 46c2 2 1 3 0 5l-2 1v-4a2 2 0 012-2z" />
      <path
        style={styleThree}
        d="M565 31a7 7 0 01-2 0l-1-2v-2l4-1a4 4 0 000 2 3 3 0 010 3 2 2 0 01-1 0z"
      />
      <path style={styleThree} d="M563 28l3-2c0 2 2 6-3 5l-1-2a5 5 0 011-1z" />
      <path
        style={styleFour}
        d="M489 91c-2 0-5-1-5-3v-1a1 1 0 001 1 8 8 0 002-1 8 8 0 011 0 1 1 0 011 1v3z"
      />
      <path
        style={styleFour}
        d="M484 88c2 1 7-4 5 3-2 0-4-1-5-3zM319 65c-3-1-3-3-2-5a7 7 0 000-3c2 2 2 3 2 5a8 8 0 000 3z"
      />
      <path style={styleFour} d="M319 65c-4-2-1-5-2-8 2 2 1 5 2 8z" />
      <path
        style={styleTwo}
        d="M567 133a1 1 0 011 0l1 1a2 2 0 012 1 2 2 0 010 2l-4 1z"
      />
      <path style={styleTwo} d="M568 133c0 2 4 0 3 4h-4v-3l1-1z" />
      <path
        style={styleFour}
        d="M376 158a12 12 0 013-1 3 3 0 013 3 2 2 0 01-1 0 5 5 0 01-2 0 5 5 0 00-1 0 1 1 0 00-1 1z"
      />
      <path style={styleFour} d="M382 160c-1 1-4-1-5 1l-1-3c3-1 5-1 6 2z" />
      <path
        style={styleFive}
        d="M493 22l-2-2h-1l1-1h1a5 5 0 012-1 2 2 0 012 1 1 1 0 010 1 2 2 0 01-1 1 4 4 0 01-2 1z"
      />
      <path style={styleFive} d="M491 20c1-1 3-2 4-1v2c-2 1-4 1-4-2z" />
      <path
        style={styleFour}
        d="M241 63l-1-1a6 6 0 00-3-1 4 4 0 00-1 0v-3a10 10 0 002 1l3 1a4 4 0 010 3z"
      />
      <path
        style={styleFour}
        d="M236 60v-1c2 0 6-1 5 4-2-2-3-3-5-3zM323 84c-3-2-2-4-2-6h1v-1l1 7z"
      />
      <path style={styleFour} d="M323 84c-3-2-2-4-1-6zM440 133h1l2 5v1l-2 1z" />
      <path style={styleFour} d="M443 139l-1 1-1-7c2 2 2 4 2 6z" />
      <path
        style={styleFive}
        d="M451 176a6 6 0 01-2 0l-1-1a3 3 0 012-1 7 7 0 012 0l1 1a3 3 0 01-2 1z"
      />
      <path style={styleFive} d="M448 175c2-2 3-1 5 0-1 2-3 1-5 0z" />
      <path
        style={styleFour}
        d="M54 33a5 5 0 001-2c0-2 0-3 2-4v1a5 5 0 000 2c0 1-1 3-3 3h-1z"
      />
      <path style={styleFour} d="M57 28c-1 1 0 5-3 5 1-1 0-4 3-5z" />
      <path style={styleFive} d="M36 115a7 7 0 012-7v2c0 2 0 4-2 5z" />
      <path
        style={styleFive}
        d="M36 115a7 7 0 012-7c0 3 1 5-2 7zM319 135a3 3 0 010-3 3 3 0 012-1h1a3 3 0 010 3 3 3 0 01-3 1z"
      />
      <path style={styleFive} d="M319 135c-1-2 0-3 2-4 1 3 0 4-2 4z" />
      <path
        style={styleFour}
        d="M327 113l-1-1a1 1 0 010-2l2-1a2 2 0 012 3 3 3 0 00-2 0 3 3 0 01-1 1z"
      />
      <path
        style={styleFour}
        d="M330 112c-2 0-3 1-4-1l2-2a2 2 0 012 3zM88 45a6 6 0 013-4v-1 1c0 2-1 3-3 4z"
      />
      <path
        style={styleFour}
        d="M91 41c0 2-1 3-3 4a6 6 0 013-4zM24 77l-3-1 1-2 1-1h1l1 3-1 1z"
      />
      <path
        style={styleFour}
        d="M24 77c-5-1-1-3-1-4 1 1 2 1 2 3l-1 1zM91 40a5 5 0 000-2l3-4v1a6 6 0 00-1 2c0 1 0 3-2 4h-1z"
      />
      <path
        style={styleFour}
        d="M94 34c-1 2 0 5-3 6 1-1 0-5 3-6zM571 153a5 5 0 01-2 0v-1l2-1a2 2 0 011 1l-1 1z"
      />
      <path style={styleFour} d="M569 153c1-2 1-3 3-1 0 2-2 1-3 1z" />
      <path style={styleFive} d="M5 154a3 3 0 010-3v-1 1l2 1-2 2z" />
      <path style={styleFive} d="M5 151c1 0 3 1 0 3a3 3 0 010-3z" />
      <path style={styleFour} d="M49 41v-1a6 6 0 012-3c0 2 1 4-2 5z" />
      <path
        style={styleFour}
        d="M51 37c0 2 0 4-2 4 0-1 0-3 2-4zM329 108a2 2 0 01-2-1 2 2 0 010-1 2 2 0 012-2h1l-1 4z"
      />
      <path
        style={styleFour}
        d="M329 108l-2-2c1-2 2-1 3-1l-1 3zM54 33a3 3 0 010 3 3 3 0 01-3 1z"
      />
      <path style={styleFour} d="M54 33c0 2-1 3-3 4l3-4z" />
      <path style={styleFive} d="M150 136c-2-1-3-3-3-5v-1c2 1 3 4 3 6z" />
      <path style={styleFive} d="M147 131c2 1 3 3 3 5-2-1-3-3-3-5z" />
      <path
        style={styleFour}
        d="M585 139a11 11 0 01-1 0 3 3 0 011-3h2a3 3 0 010 2 2 2 0 01-2 1z"
      />
      <path
        style={styleFour}
        d="M585 136h2c1 3-1 3-3 3a3 3 0 011-3zM211 119a2 2 0 01-2-1 4 4 0 010-3 5 5 0 012 3v1z"
      />
      <path
        style={styleFour}
        d="M211 118c-2 0-2-1-2-3a5 5 0 012 3zM85 49a4 4 0 012-3v1a3 3 0 010 2 2 2 0 01-2 1z"
      />
      <path style={styleFour} d="M87 47c0 1 0 2-2 3a4 4 0 012-3z" />
      <path
        style={styleFive}
        d="M445 175a1 1 0 01-1-1 1 1 0 010-1 2 2 0 011-1l1 2a1 1 0 01-1 1z"
      />
      <path style={styleFive} d="M445 172l1 2h-2l1-2z" />
      <path
        style={styleFour}
        d="M375 154a3 3 0 01-3-3 3 3 0 012 1 2 2 0 011 2z"
      />
      <path
        style={styleFour}
        d="M372 151c2 0 3 1 3 3a3 3 0 01-3-3zM114 45a3 3 0 01-1-3v-1a2 2 0 012 1 3 3 0 01-1 2v1z"
      />
      <path style={styleFour} d="M114 45l-1-4c2 1 1 2 1 4z" />
      <path style={styleTwo} d="M611 155l-1-2h2l-1 2zM611 154v-1 1z" />
      <path
        style={styleFour}
        d="M317 58a6 6 0 00-1-1h-1a1 1 0 010-1 2 2 0 011-1h1v3z"
      />
      <path
        style={styleFour}
        d="M317 57h-2l2-2zM326 98l-1-2 2 1a2 2 0 01-1 1z"
      />
      <path style={styleFour} d="M327 97c-1 1-2 0-2-1zM435 95l2 1-1 2h-1z" />
      <path
        style={styleFour}
        d="M435 96c2 0 2 1 0 2v-2zM65 57v-3l1 3a5 5 0 00-1 0zM65 57v-3 3z"
      />
      <path style={styleFive} d="M24 81v-3h2v2l-1 1z" />
      <path
        style={styleFive}
        d="M25 81h-1v-3l1 1h1v1zM551 16a1 1 0 01-1 0 1 1 0 010-1 2 2 0 011-1l1 1v1h-1z"
      />
      <path style={styleFive} d="M552 15c-1 0-1 2-2 1v-1c1-1 2-1 2 1z" />
      <path style={styleFour} d="M432 75c-2-1-2-2-1-3v-1l1 4v1z" />
      <path
        style={styleFour}
        d="M431 72l1 3c-2-1-1-2-1-3zM238 168a3 3 0 01-1-4 3 3 0 011 4zM238 168l-1-4 1 4zM24 79l-1-2 1-1h1l1 3h-2z"
      />
      <path style={styleFour} d="M26 79l-2-1v-1h1z" />
      <path
        style={styleFive}
        transform="rotate(-63 262 104)"
        d="M262 103h1v1h-1z"
      />
      <path
        style={styleFive}
        d="M263 103l-1 1zM319 141h1a2 2 0 010 2 2 2 0 01-1 1zM319 144v-2 2z"
      />
      <path style={styleFour} d="M134 149l-2-2v-1h1l1 2v1z" />
      <path
        style={styleFour}
        d="M133 147l1 2c-1-1-2-1-1-2zM23 73a2 2 0 01-1-2v-1a2 2 0 011 1 2 2 0 010 1v1z"
      />
      <path
        style={styleFour}
        d="M23 73a2 2 0 01-1-2c2 0 1 1 1 2zM671 135l1 1zM672 136l-1-1 1 1z"
      />
      <path style={styleFive} d="M319 137l-1-1 1-1v2zM319 137v-1z" />
      <path style={styleFour} d="M435 92l1 1-1 1zM435 93v1z" />
      <path style={styleFive} d="M24 77l1-2v2h-1z" />
      <path style={styleFive} d="M25 77h-1l1-1z" />
      <path
        style={styleFour}
        d="M432 79a1 1 0 000-1l1 1-1 1zM432 79v1a4 4 0 010-1z"
      />
      <path
        style={styleThree}
        d="M628 118a1 1 0 01-1 0l-1-1 3 1h-1zM628 118h-1z"
      />
      <path
        style={styleFour}
        transform="rotate(-20 434 87)"
        d="M433 87h1v1h-1z"
      />
      <path style={styleFour} d="M433 87l1 1zM87 45h1a1 1 0 010 1h-1zM88 45z" />
      <path style={styleFour} transform="rotate(-54 58 26)" d="M57 26h1-1z" />
      <path style={styleFour} d="M58 26h-1zM429 67h1a1 1 0 011 2v1z" />
      <path
        style={styleFour}
        d="M430 68a1 1 0 011 1l-1-1zM432 82h1l1 1-1 1zM433 83v1z"
      />
      <path
        style={styleFour}
        transform="rotate(-46 429 67)"
        d="M429 66h1v2h-1z"
      />
      <path style={styleFour} d="M429 67l1 1z" />
      <path
        style={styleFive}
        d="M135 83a3 3 0 001-3 100 100 0 010-14V46v-5a2 2 0 012-1 8 8 0 014 2 12 12 0 006 1 68 68 0 008 0l-1 3a3 3 0 01-1 0h-1c-1 0 0 0 0 0-1 0-2 0-3 2 0 2 1 2 2 3v1a10 10 0 00-3 6 12 12 0 00-3 7v2a2 2 0 00-1 2l-3 7c-3 2-3 4-3 6l-1 5h-3z"
      />
      <path
        style={styleFive}
        d="M136 80c-1-12 3-23 0-34 0-2-1-8 6-4 4 2 9 1 14 1l-1 2c-2 1-4-1-5 3-1 2 1 3 2 4a10 10 0 00-3 5 12 12 0 00-3 8v2a2 2 0 00-1 2l-3 7c-3 2-3 4-3 6l-1 5h-3v-4a3 3 0 001-3z"
      />
      <path
        style={styleTwo}
        d="M178 65a2 2 0 01-1 0c-2-2-3-6 0-8a6 6 0 002-4c1-6 4-9 9-9a17 17 0 014 1l2 1-1 2a24 24 0 00-6 6l-1 2v-1l-1-1v1c-1 1-2 2 0 3v1a13 13 0 00-1 1 5 5 0 01-1 2 13 13 0 00-2 1l-3 2z"
      />
      <path
        style={styleTwo}
        d="M185 59l-2 3c-2 1-4 5-6 3-1-2-3-6 0-8a6 6 0 002-4c1-7 5-10 13-8 2 1 2 2 0 3l-6 7-2-1c0 2-1 3 1 5z"
      />
      <path
        style={styleFour}
        d="M137 119a2 2 0 00-1-2 3 3 0 01-1-1 6 6 0 00-1-1 4 4 0 01-1-2 3 3 0 011-2l1-4v-1-19h3a30 30 0 003 19v1a5 5 0 001 1 6 6 0 001-2v-1a1 1 0 011 0c2 2 1 4 0 5l-1 2a22 22 0 00-3 4c0 1-1 3-3 3z"
      />
      <path
        style={styleFour}
        d="M135 87h3a31 31 0 003 19c1 2 1 3 2 0h1v4l-4 6-3 3c0-2-2-2-2-3-1-1-4-3-1-5l1-5V87zM133 137v-7-3c2 2 4 3 3 5 0 2-1 4-3 5z"
      />
      <path
        style={styleFour}
        d="M133 127c4 3 4 7 0 10v-10zM152 52c-2-1-3-2-2-5 1-2 2-2 3-2h1a2 2 0 001 0v4l-3 3z"
      />
      <path
        style={styleFour}
        d="M152 52c-1-1-3-2-2-5s3-1 5-2v4zM146 65a13 13 0 013-8l3 1-1 3-5 4z"
      />
      <path
        style={styleFour}
        d="M146 65a12 12 0 013-8c3 0 3 2 2 4l-5 4zM141 84l-2-1v-1c0-2 0-4 3-6v6l-1 2z"
      />
      <path
        style={styleFour}
        d="M139 82c0-2 0-4 3-6v6c0 4-2 2-3 0zM159 46l-1-1a2 2 0 00-1-1 3 3 0 00-1 0v-1a2 2 0 012-2 3 3 0 011 1 3 3 0 012 3 2 2 0 01-1 1 2 2 0 01-1 0z"
      />
      <path
        style={styleFour}
        d="M156 43a2 2 0 013-1 3 3 0 012 3 2 2 0 01-2 1l-1-2a7 7 0 00-2-1zM148 116l-3-1 1-3c2 1 2 3 2 4z"
      />
      <path style={styleFour} d="M148 116c-3 0-5 0-2-3 2 0 2 2 2 3z" />
      <path style={styleFive} d="M184 59v-5a1 1 0 011 0l1 1a4 4 0 01-1 4z" />
      <path style={styleFive} d="M185 59c-2-2-1-3-1-5l2 1a4 4 0 01-1 4z" />
      <path
        style={styleFour}
        d="M156 51l-1-2v-1h1a2 2 0 012 1 1 1 0 01-1 1 2 2 0 01-1 1z"
      />
      <path
        style={styleFour}
        d="M155 49h2v1l-2-1zM145 69a2 2 0 011-3l1 2-2 1z"
      />
      <path
        style={styleFour}
        d="M145 69a2 2 0 011-2c1 1 0 1-1 2zM135 83l1-4v1a4 4 0 01-1 3z"
      />
      <path
        style={styleFour}
        d="M136 80a3 3 0 01-1 3l1-3zM148 118l1-1v2l-1-1zM148 119l1-1zM607 85l-1-3v-1-6-8c0-4 1-6 5-7l1 6c-5 4-4 9-3 15a6 6 0 000 2l-2 2z"
      />
      <path
        style={styleFour}
        d="M611 61v5c-4 4-3 10-2 15l-2 4c-2-1-1-3-1-4V67c0-3 1-6 5-6zM618 134v-1a5 5 0 013-1c1 0 2 1 2 4z"
      />
      <path
        style={styleFour}
        d="M618 134c3-2 4-2 5 2zM614 81a8 8 0 01-1 0v-1a4 4 0 013-2v1l-2 2z"
      />
      <path style={styleFour} d="M613 80a3 3 0 013-1c0 2-2 2-3 1z" />
      <path style={styleThree} d="M600 162a3 3 0 01-1-3 3 3 0 011-2v5z" />
      <path style={styleThree} d="M600 157v5c-2-2-2-3 0-5z" />
      <path style={styleFour} transform="rotate(-45 611 59)" d="M611 59h1-1z" />
      <path
        style={styleFour}
        d="M612 59l-1 1zM345 147c-2-5 0-8 2-10a19 19 0 002-4h1a30 30 0 000 4c1 4 1 8-5 10z"
      />
      <path
        style={styleFour}
        d="M350 133c0 5 2 11-5 13-3-5 3-8 5-13zM352 96a4 4 0 01-2-2l-2-2a7 7 0 01-1-6 2 2 0 011-2c2 0 2 2 3 4a23 23 0 001 2c1 2 2 4 0 6z"
      />
      <path
        style={styleFour}
        d="M352 96c-2-1-1-4-4-4-2-3-2-7 0-7 2-1 3 3 4 4 0 2 3 4 0 7zM386 129l-1-6a11 11 0 00-1-4c3 0 4 2 4 4a6 6 0 001 4l-3 2z"
      />
      <path
        style={styleFour}
        d="M384 119c5 1 3 6 5 8 1 1-2 1-3 2-2-3-1-7-2-10zM339 104l-1-13v-4a37 37 0 011 17z"
      />
      <path
        style={styleFour}
        d="M339 103l-1-16a36 36 0 011 16zM341 143l-1-15 1 10v5z"
      />
      <path
        style={styleFour}
        d="M341 143l-1-15c2 5 1 10 1 15zM340 124c-2-4-1-8-1-13a28 28 0 011 13z"
      />
      <path
        style={styleFour}
        d="M340 124l-1-13a27 27 0 011 13zM348 113c-1-2-2-4 0-7l1 8z"
      />
      <path
        style={styleFour}
        d="M348 107l1 6c-2-2-3-4-1-6zM344 161a4 4 0 01-2-3 8 8 0 000-1v-1h3v1c0 1 1 3-1 4z"
      />
      <path
        style={styleFour}
        d="M345 157c0 1 1 3-1 4l-2-4zM383 77l-2-1 1-2 1 3z"
      />
      <path
        style={styleFour}
        d="M382 75l1 2c-1-1-3-1-1-2zM349 127a3 3 0 011 1v1h-1z"
      />
      <path
        style={styleFour}
        d="M349 127a5 5 0 011 1h-1v-1zM348 116a1 1 0 000-1h1v2h-1z"
      />
      <path
        style={styleFour}
        d="M349 116v1a4 4 0 01-1-1h1zM349 121a3 3 0 01-1 0l1-1v2z"
      />
      <path
        style={styleFour}
        d="M349 121v1a4 4 0 01-1-1h1zM345 153a3 3 0 01-1 0l1-1v2z"
      />
      <path style={styleFour} d="M345 153v1a4 4 0 01-1-1h1z" />
      <path
        style={styleTwo}
        d="M519 104c-2-5-3-11-3-16v-3a7 7 0 010-1c0-1 0-3-2-3v-1a5 5 0 012-2c1 0 2-1 2-3l1-3 2 2a3 3 0 010 1 2 2 0 001 2v3a52 52 0 000 9 50 50 0 010 10c-1 3-1 4-3 5z"
      />
      <path
        style={styleTwo}
        d="M519 103c-3-5-3-12-3-18 0-1 1-4-2-4 1-3 5-3 4-6 0-3 1-3 3-1l1 4v2 19c-1 3-1 4-3 4z"
      />
      <path
        style={styleFour}
        d="M523 126l-1-4c-2-5-4-9-2-14a6 6 0 00-1-3v-2c2 0 2-2 2-4a50 50 0 001-10 52 52 0 010-9v-1c3 9 4 18 2 28-1 5-2 11 0 17a2 2 0 010 1 5 5 0 00-1 1z"
      />
      <path
        style={styleFour}
        d="M519 103c2 0 2-1 3-4V80c3 8 3 18 2 27-1 6-2 11 0 17l-1 2c-2-6-5-12-3-18l-1-5z"
      />
      <path
        style={styleFive}
        d="M505 89l1-6 1-5 1-4 1-1 6-8v6a3 3 0 001 3 2 2 0 001 0h1v1c1 2-1 3-2 4a5 5 0 00-2 2c-3 0-4 2-5 5a14 14 0 01-3 4z"
      />
      <path
        style={styleFive}
        d="M518 75c1 3-3 3-4 6-4 1-5 6-8 8-2-4 2-7 1-11l1-4 1-1 6-7v5c0 3 1 4 3 4z"
      />
      <path
        style={styleFour}
        d="M505 93h-1c-2-1-3-2-3-5a11 11 0 011-3c1-2 2-3 1-5a1 1 0 010-1l4-2c1 3 0 4-1 6v7l1 2-2 1z"
      />
      <path
        style={styleFour}
        d="M507 78c1 4-3 7-1 11 0 2 2 4-2 4-2-1-3-2-3-5 1-3 3-5 2-9 0-1 2-2 4-1zM522 78a3 3 0 01-1-3 3 3 0 000-1l-2-1-1 2h-1a3 3 0 01-2-1 3 3 0 010-3v-4-1a3 3 0 001-2l1-1a1 1 0 011 0c2 1 1 2 1 3a7 7 0 00-1 2c0 1 0 2 2 3a4 4 0 013 2l-1 5z"
      />
      <path
        style={styleFour}
        d="M518 75c-2 0-3-1-3-4v-5c1-1 1-4 3-3s0 3 0 4c0 2 0 3 2 4 4 1 4 4 2 7l-1-4c-2-2-3-2-3 1zM508 73h1l-1 1v-1zM509 73l-1 1zM28 132c-5-4-6-9-6-14l-1-5a34 34 0 00-2-4 28 28 0 01-1-5 6 6 0 010-3 4 4 0 00-1-2 2 2 0 00-1 0 7 7 0 00-2 0c-2-2-3-4 0-6a2 2 0 001-2 5 5 0 00-2-3c-3-3-3-6-3-9a26 26 0 00-1-4 2 2 0 011-1v-1h1c0 2 2 2 3 2 2 1 4 1 4 3l1 2a4 4 0 002-1 5 5 0 012-1 2 2 0 011 0v3h-1l-4 2a2 2 0 001 2 2 2 0 001 1 5 5 0 002 0l1 1c-2 2-1 4 0 7 0 2 1 5-1 7a2 2 0 000 2 2 2 0 002 1 4 4 0 013 1l1 4v2c-3 4-2 9-2 14a37 37 0 011 7v1z"
      />
      <path
        style={styleFour}
        d="M24 78v3c-2 0-5 0-5 2s1 4 4 3l1 1c-4 4 2 9-1 14a2 2 0 002 3c5 0 4 4 4 6-5 7-1 15-1 22-6-5-6-12-7-19l-3-9c-1-2 1-7-4-5-1-2-3-4 0-6 2-2 0-4-1-5-3-4-2-9-4-13l1-2c2 4 7 1 8 6 1 3 4-2 6-1zM27 92a5 5 0 000-3v-4h3l-2 7z"
      />
      <path
        style={styleFour}
        d="M27 85h3l-2 7c0-2-3-4-1-7zM25 82a3 3 0 010-1l1-2v1a2 2 0 01-1 2z"
      />
      <path style={styleFour} d="M25 81l1-1a1 1 0 01-1 2 3 3 0 010-1z" />
      <path
        style={styleThree}
        d="M452 128l-4-14a88 88 0 00-2-9 18 18 0 01-1-2c0-2 0-4-2-5v-2l-1-2h1a10 10 0 012 0c2 0 2 1 3 3l1 5c2 8 3 17 3 26z"
      />
      <path
        style={styleThree}
        d="M443 95c2-1 4-2 5 2 2 10 4 20 4 31-3-7-4-15-6-23-1-2-1-5-3-7v-2z"
      />
      <path style={styleFour} d="M443 144l-1-1h2v-1 2a1 1 0 00-1 0z" />
      <path style={styleFour} d="M444 144l-1-1a9 9 0 011 0v1z" />
      <path style={styleFive} d="M442 99a1 1 0 010-1c-1-1 0-1 1-2v2l-1 1z" />
      <path style={styleFive} d="M443 96v2h-1c-1-1 0-1 1-2z" />
      <path style={styleThree} d="M452 127l1 1-1 2zM452 128v0z" />
      <path style={styleFour} d="M444 139a2 2 0 011 1 2 2 0 010 2h-1z" />
      <path style={styleFour} d="M444 142v-2a1 1 0 010 2z" />
      <path
        style={styleFive}
        d="M313 115l-2-2c-5-5-5-11-5-17a60 60 0 00-1-6 15 15 0 00-1-5c-3-6-4-12-4-18a83 83 0 00-1-10 5 5 0 010-3c1-1 2-4 4-4a2 2 0 011 0l2 2a5 5 0 000 1 27 27 0 013 6v2c-4 2-5 4-3 9l1 3 7 25a14 14 0 01-1 4 11 11 0 000 5 6 6 0 011 1v1l2-1v2c0 1 1 3-1 4a2 2 0 01-2 1z"
      />
      <path
        style={styleFive}
        d="M316 109c0 1 1 3-1 5-1 0-2 1-3-1-7-7-5-15-6-23a16 16 0 00-2-5c-5-9-3-19-5-28a5 5 0 010-2l4-5c2 0 2 2 3 4l3 7c-4 2-5 5-3 9 3 9 6 18 7 28v9c1 1 0 4 3 2z"
      />
      <path
        style={styleTwo}
        d="M314 110l-1-2a6 6 0 000-1 11 11 0 010-5 14 14 0 000-4c-1-9-4-17-6-25l-2-3c-1-5 0-7 4-9v2c0 2 0 3 2 4l9 31v3l-1 2c-2 0-2 1-2 2v2l-1 2a3 3 0 01-2 1z"
      />
      <path
        style={styleTwo}
        d="M316 109c-3 2-2-1-3-2v-9c-1-10-4-19-7-28-2-4-1-7 3-9 0 3-1 5 2 6l9 31-1 2v2c-2 1-2 2-2 4z"
      />
      <path style={styleFive} d="M311 68c-2-2-2-3-2-5v-2a10 10 0 012 6v1z" />
      <path
        style={styleFive}
        d="M311 67c-3-1-2-3-2-6a10 10 0 012 6zM317 106c0-2 0-4 2-4v1c0 1 0 3-2 3z"
      />
      <path style={styleFive} d="M317 106c0-2 0-3 2-4 0 2 0 3-2 4z" />
      <path style={styleFive} transform="rotate(-78 319 99)" d="M319 99h1-1z" />
      <path
        style={styleFive}
        d="M319 100l1-2zM319 101h1v1l-1 1zM319 102v-1 1z"
      />
      <path
        style={styleFour}
        d="M97 150a2 2 0 01-2-1v-6l2-3-3-1c-3 0-3-2-4-4l-1-8-2-8a7 7 0 010-2c0-1 0-2-2-2a5 5 0 00-1 0l-1-1v-1c2-2 2-4 2-7l1-7 2 1c0 8 1 16 4 26 0 2 1 2 2 2a2 2 0 002-1c1-3 2-4 4-5a13 13 0 003 1 6 6 0 004-1v-1 1a16 16 0 000 2c0 2 0 4-4 5a6 6 0 00-1 3 1 1 0 001 1 3 3 0 001 0h1v1a46 46 0 01-3 7 39 39 0 00-3 8 2 2 0 01-2 1z"
      />
      <path
        style={styleFour}
        d="M100 122h7c0 3 1 6-4 7l-1 3c0 2 2 1 3 2l-7 15c0 2-2 2-3 0v-6c3-3 2-3-1-4-3 0-3-3-3-4l-4-16c0-2 1-5-3-4l-1-1c3-5 1-10 3-15l2 1a98 98 0 004 26c0 2 1 3 2 3 2 0 2-1 3-2a5 5 0 013-5z"
      />
      <path
        style={styleFive}
        d="M117 100l-1-1-1-2-3-3v-1a11 11 0 00-1-11v-1l2-2a2 2 0 00-1-1 5 5 0 010-3l-1-4v-1l-2-2v-1a3 3 0 001-1c0-2 0-3 2-3a5 5 0 001 1l1 1 1 8c2 6 3 12 3 19v8z"
      />
      <path
        style={styleFive}
        d="M112 63l2 2c1 9 4 17 4 27v8l-1-1h-1l-1-2-3-4a11 11 0 00-1-11v-1c2-1 3-2 1-3v-1c-1-2 2-5-1-7l-2-2c2-1 0-5 3-5z"
      />
      <path
        style={styleTwo}
        d="M85 86v-1a3 3 0 00-1-1v-2c0-6 2-11 5-16a62 62 0 004-7 5 5 0 011 0c2 0 2 2 2 4a6 6 0 010 3 5 5 0 00-1 3v1a14 14 0 01-3 4c-1 2-3 4-3 7l-1 1a8 8 0 00-1 2l-2 2z"
      />
      <path
        style={styleTwo}
        d="M95 69c-1 5-6 7-6 12l-3 3c-1 5-1-1-2 0v-2c0-9 6-15 9-22 3-1 3 1 3 3 1 2-2 4-1 6zM94 129c-2 0-2-2-2-3-3-10-4-18-4-26 2 0 2 2 2 3l2 2a25 25 0 011 6c1 3 1 6 4 9l2 1a3 3 0 001 0 6 6 0 010 1v1c-2 0-3 2-3 4a2 2 0 01-3 2z"
      />
      <path
        style={styleTwo}
        d="M100 122a5 5 0 00-3 5c-1 1-1 2-3 2-1 0-2-1-2-3a98 98 0 01-4-26c3 1 1 5 4 5 2 5 1 11 5 15l3 1v1z"
      />
      <path
        style={styleFour}
        d="M109 102a8 8 0 01-2 0l-2-6-2-11v-1-3-1a2 2 0 00-1 1h-1v-4-1h-1v-4c2 0 2-2 2-3a10 10 0 010-2c3 1 3 3 3 4 0 6 1 11 3 17a114 114 0 012 11 3 3 0 010 3 1 1 0 01-1 0z"
      />
      <path
        style={styleFour}
        d="M107 102c-1-6-4-11-4-17l1-4h-2c0-2 1-3-1-4v-1a5 5 0 00-1 0v-3c2-2 2-4 2-6l3 4c0 10 4 19 5 28 0 3-1 3-3 3z"
      />
      <path
        style={styleFive}
        d="M100 73a8 8 0 01-1-2l-2-2a4 4 0 00-2 1 6 6 0 010-4 6 6 0 001-3c0-2-1-3-2-3a5 5 0 00-1 0c-1-2 0-3 1-3l1-3v-4l3-2a4 4 0 012-2v1a3 3 0 010 2v5c-1 2 0 4 1 6v1l1 2a2 2 0 000 2v2a12 12 0 000 2c0 1 0 3-2 4z"
      />
      <path
        style={styleFive}
        d="M102 67c0 2 0 4-2 6-1-2-1-7-5-4-1-2 2-4 1-6 0-2 0-4-3-3-1-3 3-4 2-6v-3c3-1 3-4 5-4 0 2-2 3 0 5v2a8 8 0 001 7v2a2 2 0 001 3zM105 134h-1a3 3 0 01-2-1 2 2 0 010-1l1-4c3 0 4-2 4-4a16 16 0 010-2 5 5 0 001-1l1-1v-3a2 2 0 001 0v-2a3 3 0 010-1v-1a3 3 0 011 0 2 2 0 001 1l1-1 1-1a14 14 0 003-9v-1l2 1c0 4 0 9-4 12l-4 8-2 4v1a10 10 0 00-1 2 7 7 0 01-3 4z"
      />
      <path
        style={styleFive}
        d="M105 134c-1-1-3 0-3-2l1-3c5-1 4-4 4-7a5 5 0 001 0l1-2v-1-1c3-1 1-3 1-4a3 3 0 011 0c2 1 2 0 3-2a14 14 0 003-9h2c0 4 0 9-4 12-3 3-4 8-6 11v1l-4 7zM92 106c-2-1-2-2-2-3l-2-2-2-1-1-3a8 8 0 00-1-5v-2l-1-5 1-1v-1l1 2v1l1-2a9 9 0 012-2l1-2v1c-1 4 0 8 1 13l2 11v1z"
      />
      <path
        style={styleFive}
        d="M92 105c-3 0-1-4-4-5l-2-1v-2a8 8 0 00-2-5v-2-6c1-1 1 5 2 0l3-3c-2 8 4 16 3 24z"
      />
      <path
        style={styleFour}
        d="M114 112a5 5 0 010-1l-1-2a3 3 0 00-1 0 5 5 0 01-1 0 1 1 0 01-1 0 1 1 0 010-1l2-2a4 4 0 002 0l1-1 2-3v1a14 14 0 01-3 9z"
      />
      <path
        style={styleFour}
        d="M117 103a14 14 0 01-3 9c0-2 1-3-2-3-1 0-2 1-1-1a4 4 0 011-2c4 3 3-3 5-3zM109 68c-2-2-1-4-1-6l1-2a2 2 0 012-1 3 3 0 011 1l1 2a2 2 0 00-1 1v1l-2 2a3 3 0 01-1 2z"
      />
      <path
        style={styleFour}
        d="M112 63c-3 0-1 4-3 5-2-3-1-5 0-8h3c2 1 0 2 0 3zM112 94c-2-4-2-9-1-12a12 12 0 012 12h-1z"
      />
      <path
        style={styleFour}
        d="M111 82a11 11 0 011 11c-2-3-2-7-1-11zM95 51a9 9 0 000-2l1-4a1 1 0 001 0 3 3 0 001 0 4 4 0 011 0l1 2a4 4 0 00-2 2c-1 1-1 2-3 2z"
      />
      <path
        style={styleFour}
        d="M100 47c-2 0-2 3-5 4 0-2-1-4 1-6 1 2 4-2 4 2zM84 91a8 8 0 012 6 2 2 0 00-1 0 3 3 0 00-2 0 5 5 0 01-2 1z"
      />
      <path
        style={styleFour}
        d="M84 92a8 8 0 012 5c-2-1-3 1-5 1zM101 61c-2-3-2-5-1-8 3 2 3 4 1 8z"
      />
      <path
        style={styleFour}
        d="M101 61a8 8 0 01-1-7c3 1 3 4 1 7zM78 88a17 17 0 000-2v-5h2l-1 7z"
      />
      <path
        style={styleFour}
        d="M79 88c-1-3-2-5-1-6a2 2 0 011-1v7zM100 52v-3a3 3 0 000-2l3 2c0 2-2 3-3 3z"
      />
      <path
        style={styleFour}
        d="M100 52c-2-2 0-3 0-5l3 2c0 2-2 2-3 3zM112 78a3 3 0 01-2-2 4 4 0 010-3l1-2v-1c2 2 2 3 1 5a5 5 0 000 2v1z"
      />
      <path
        style={styleFour}
        d="M111 70c3 2 0 5 1 7-5-1 0-4-1-7zM84 90l-2-2s0-2 2-3v5z"
      />
      <path
        style={styleFour}
        d="M84 85v5c-3-2-3-3 0-5zM109 118a8 8 0 000-1l1-4v1a3 3 0 001 1 2 2 0 01-2 3z"
      />
      <path style={styleFour} d="M110 114c0 1 2 3-1 4l1-4zM117 103v-4h1l1 4z" />
      <path
        style={styleFour}
        d="M119 103h-2v-4l1 1 1 3zM111 81a3 3 0 011-3v-1a2 2 0 011 2l-2 2z"
      />
      <path
        style={styleFour}
        d="M112 78c2 1 1 2-1 3l1-3zM112 115a2 2 0 01-1-1v-1a3 3 0 012-1h1v1l-2 2z"
      />
      <path
        style={styleFour}
        d="M114 112c-1 2-1 3-3 2l3-2zM84 121v-1h1a1 1 0 011 0 1 1 0 010 1l-1 1z"
      />
      <path
        style={styleFour}
        d="M85 121h-1a3 3 0 011-1l1 1h-1zM105 109a3 3 0 012-4v1c0 1 0 2-2 3z"
      />
      <path
        style={styleFour}
        d="M105 109a3 3 0 012-3c0 1 0 2-2 3zM102 66a2 2 0 01-1-3l2 1-1 2z"
      />
      <path
        style={styleFour}
        d="M102 66a2 2 0 01-1-3c1 1 2 1 1 3zM76 86a1 1 0 01-1 0 1 1 0 010-1 3 3 0 001 0h1a1 1 0 01-1 1z"
      />
      <path
        style={styleFour}
        d="M76 85a1 1 0 010 1 1 1 0 01-1 0l1-1zM84 84l-2-1c0-2 1-2 2-2v3z"
      />
      <path
        style={styleFour}
        d="M84 82v2l-2-1 2-1zM80 78a2 2 0 010-1v-1l1 1v1a2 2 0 01-1 0z"
      />
      <path
        style={styleFour}
        d="M81 77a4 4 0 01-1 1 3 3 0 010-1zM95 54a2 2 0 01-1-2 2 2 0 011-2v4zM95 51v3-3zM104 112a3 3 0 011-3l-1 4zM104 113l1-4-1 4zM102 116c-1-1 0-1 1-2a2 2 0 01-1 3z"
      />
      <path
        style={styleFour}
        d="M102 116l1-1a1 1 0 01-1 1zM101 119a2 2 0 011-3 2 2 0 01-1 3z"
      />
      <path
        style={styleFour}
        d="M101 119a2 2 0 011-2 2 2 0 01-1 2zM116 99a2 2 0 01-1-2l2 2z"
      />
      <path
        style={styleFour}
        d="M115 97l1 2a2 2 0 01-1-2zM107 103l1 2-1 1zM107 105v-1 1zM104 112v1a1 1 0 01-1 2z"
      />
      <path
        style={styleFour}
        d="M103 114l1-1a1 1 0 01-1 1zM109 119l-1-1 1-1v2z"
      />
      <path
        style={styleFour}
        d="M109 118v1a4 4 0 010-1zM85 133v-1 1zM85 133zM100 121a1 1 0 011-2l-1 2z"
      />
      <path style={styleFour} d="M100 121a1 1 0 011-2l-1 2z" />
      <path
        style={styleFour}
        transform="rotate(-52 108 121)"
        d="M108 121h1-1z"
      />
      <path
        style={styleFour}
        d="M109 121l-1 1 1-1zM248 60a7 7 0 01-3-1 6 6 0 00-2-1 1 1 0 01-1 0v-2a3 3 0 001-1v-1l-2-2-2-2a1 1 0 011-1l2-3c2-3 4-5 8-7v1c0 2-1 3-3 4a12 12 0 00-1 2l-3 6 5 4a14 14 0 011 1h1v1a3 3 0 01-2 2z"
      />
      <path
        style={styleFour}
        d="M250 40c0 3-3 4-4 6-4 5-4 6 2 10a26 26 0 012 2c-2 3-5 0-7 0s0-2 0-3v-1c0-3-5-3-3-5 3-4 5-8 10-9zM250 39c0-2 1-4 4-5v1c0 2-2 3-4 5z"
      />
      <path
        style={styleFour}
        d="M254 35c0 2-2 3-4 4 0-2 1-4 4-4zM268 87c-1 0-2-1-2-3h-1l1-1 1 1a2 2 0 001 0l1-1 2 1v1l-3 2z"
      />
      <path style={styleFour} d="M271 85c-2 1-4 3-5-1v-1c1 1 2 2 3 1z" />
      <path
        style={styleFive}
        d="M268 85a3 3 0 01-1-1h-1v-3a5 5 0 013 2v1a2 2 0 01-1 1z"
      />
      <path style={styleFive} d="M269 84c-1 1-2 0-3-1v-2a5 5 0 013 3z" />
      <path style={styleFour} d="M259 119a2 2 0 01-1 3zM258 122l1-3-1 3z" />
      <path
        style={styleFour}
        transform="rotate(-58 260 116)"
        d="M260 116h1-1z"
      />
      <path style={styleFour} d="M260 116l1-1-1 1z" />
      <path style={styleFive} d="M264 107h1v-1 1l-1 1v-1zM264 108l1-1-1 1z" />
      <path style={styleFour} d="M558 123a3 3 0 00-1 0v-1h2v1h-1z" />
      <path style={styleFour} d="M559 122l-1 1h-1l1-1h1z" />
      <path style={styleFive} d="M228 110a2 2 0 010-4v4z" />
      <path
        style={styleFive}
        d="M228 107v3a2 2 0 010-3zM385 65h-1v-2l1 2h-1 1zM385 65l-1-2zM384 73v-2l1 1-1 1zM384 73l1-2-1 2zM567 55h1v1l-1-1z"
      />
      <path style={styleFive} d="M568 55v1l-1-1h1z" />
      <path style={styleFour} transform="rotate(-37 613 65)" d="M613 65h1-1z" />
      <path style={styleFour} d="M613 65h1z" />
      <path style={styleFive} d="M616 93v-1 1zM616 93z" />
      <path
        style={styleTwo}
        d="M145 122l-3-2a1 1 0 010-1 1 1 0 011 0c2 0 2 1 3 2a3 3 0 000 1h-1z"
      />
      <path style={styleTwo} d="M146 121l-1 1-2-2v-1l3 2z" />
      <path
        style={styleOne}
        d="M72 86h1v1l-1-1zM73 87v-1zM78 106h1v1l-1-1zM79 107v-1z"
      />
      <path style={styleFour} d="M671 145l-1-1a2 2 0 010-1h1l1 1-1 1z" />
      <path
        style={styleFour}
        d="M672 144l-1 1-1-1 1-1zM672 141l1-1v1zM673 140v0z"
      />
      <path
        style={styleTwo}
        d="M574 134a2 2 0 01-1 0 1 1 0 010-1 1 1 0 010-1 2 2 0 011 1h1v1h-1z"
      />
      <path
        style={styleTwo}
        d="M575 133l-1 1a2 2 0 01-1-1c-1 0 0 0 0 0a6 6 0 012 0z"
      />
      <path
        style={styleFive}
        d="M101 81h1a2 2 0 011-1 1 1 0 011 1c1 1 0 2-1 3v1z"
      />
      <path
        style={styleFive}
        d="M102 81h2l-1 4zM101 81a7 7 0 010-4v-1 1c2 1 1 3 1 4z"
      />
      <path
        style={styleFive}
        d="M101 77c2 1 1 2 1 4a6 6 0 01-1-4zM100 77a3 3 0 010-1 1 1 0 000-1l1 1a1 1 0 010 1z"
      />
      <path style={styleFive} d="M100 76a5 5 0 011 0v1a4 4 0 01-1-1z" />
    </svg>
  );
}
